///<reference types="angular" />
///<reference types="angular-ui-router" />
///<reference types="angular-material" />
///<reference types="jquery" />
///<reference types="moment" />
///<reference types="moment-timezone" />
///<reference types="ngstorage" />
///<reference path="src/extras/utils.ts" />
///<reference path="src/models/models.ts" />
///<reference path="src/filters/filters.ts" />
///<reference path="src/directives/permission.ts" />
///<reference path="src/directives/compareTo.ts" />
///<reference path="src/directives/directives.ts" />
///<reference path="src/services/negotiationsService.ts" />
///<reference path="src/services/paymentsService.ts" />
///<reference path="src/services/customersService.ts" />
///<reference path="src/services/filesService.ts" />
///<reference path="src/services/agentsService.ts" />
///<reference path="src/services/grantersService.ts" />
///<reference path="src/services/authService.ts" />
///<reference path="src/services/utilsService.ts" />
///<reference path="src/services/services.ts" />
///<reference path="src/app/activities/report/report.ts" />
///<reference path="src/app/activities/activities.ts" />
///<reference path="src/app/payments/list/list.ts" />
///<reference path="src/app/payments/payments.ts" />
///<reference path="src/app/negotiations/list/list.ts" />
///<reference path="src/app/negotiations/paid/paid.ts" />
///<reference path="src/app/negotiations/detail/detail.ts" />
///<reference path="src/app/negotiations/negotiations.ts" />
///<reference path="src/app/customers/timeline/timeline.ts" />
///<reference path="src/app/customers/detail/detail.ts" />
///<reference path="src/app/customers/customers.ts" />
///<reference path="src/app/admin/cancel/cancel.ts" />
///<reference path="src/app/admin/create/create.ts" />
///<reference path="src/app/admin/search/search.ts" />
///<reference path="src/app/admin/findNegotiation/findNegotiation.ts" />
///<reference path="src/app/admin/update/update.ts" />
///<reference path="src/app/admin/find/find.ts" />
///<reference path="src/app/admin/create_reference/create_reference.ts" />
///<reference path="src/app/admin/change_sic/change_sic.ts" />
///<reference path="src/app/admin/admin.ts" />
///<reference path="src/app/customers/cancel_negotiation.ts" />
///<reference path="src/app/search/search.ts" />
///<reference path="src/app/upload/upload.ts" />
///<reference path="src/app/changePassword/forgotPassword.ts" />
///<reference path="src/app/changePassword/changePassword.ts" />
///<reference path="src/app/register/register.ts" />
///<reference path="src/app/findYourCredit/findYourCredit.ts" />
///<reference path="src/app/payYourCredit/payYourCredit.ts" />
///<reference path="src/app/login/login.ts" />
///<reference path="src/app/granters/create/create.ts" />
///<reference path="src/app/granters/list/list.ts" />
///<reference path="src/app/granters/granters.ts" />
///<reference path="src/app/agents/create/create.ts" />
///<reference path="src/app/agents/list/list.ts" />
///<reference path="src/app/agents/agents.ts" />
///<reference path="src/app/dashboard/dashboard.ts" />
///<reference path="src/app/lang.ts" />
///<reference path="src/app/config.ts" />
///<reference path="src/app/app.ts" />

Date.prototype.compare = function (x) {
    var result = this.getTime() - x.getTime();
    return result;
};
var Dictionary = /** @class */ (function () {
    function Dictionary() {
    }
    return Dictionary;
}());
var Helpers = /** @class */ (function () {
    function Helpers() {
    }
    Helpers.range = function (start, end, step) {
        if (end === void 0) { end = -1; }
        if (step === void 0) { step = 1; }
        if (end < 0) {
            end = start;
            start = 0;
        }
        var result = [];
        for (var i = start; i < end; i += step) {
            result.push(i);
        }
        return result;
    };
    Helpers.clone = function (obj) {
        return Object.keys(obj).reduce(function (prev, cur) {
            prev[cur] = obj[cur];
            return prev;
        }, {});
    };
    Helpers.cloneStringElements = function (obj) {
        return Object.keys(obj).reduce(function (prev, cur) {
            if (typeof obj[cur] === 'string') {
                prev[cur] = obj[cur];
            }
            return prev;
        }, {});
    };
    Helpers.cloneSpecificStringElements = function (obj, list) {
        return Object.keys(obj).reduce(function (prev, cur) {
            if (typeof obj[cur] === 'string' && list.indexOf(cur) !== -1) {
                prev[cur] = obj[cur];
            }
            return prev;
        }, {});
    };
    return Helpers;
}());
Array.prototype.sortBy = function (getterFunc) {
    var getter = function (x) { return x; };
    if (getterFunc) {
        getter = getterFunc;
    }
    return this.sort(function (x, y) {
        var valX = getter(x);
        var valY = getter(y);
        if (valX > valY) {
            return 1;
        }
        if (valX == valY) {
            return 0;
        }
        if (valX < valY) {
            return -1;
        }
    });
};
Array.prototype.min = function () {
    var getter = function (x) { return x; };
    return this.sortBy(getter).first();
};
Array.prototype.pushAll = function (values) {
    var _this = this;
    values.forEach(function (x) { return _this.push(x); });
    return this;
};
Array.prototype.max = function () {
    var getter = function (x) { return x; };
    return this.sortBy(getter).last();
};
Array.prototype.head = function () {
    if (this.length <= 1) {
        return this;
    }
    this.reverse();
    var result = this.slice(1);
    result.reverse();
    return result;
};
Array.prototype.tail = function () {
    if (this.length <= 1) {
        return this;
    }
    return this.slice(1);
};
Array.prototype.firstOrDefault = function (defaultValue) {
    return typeof this[0] == 'undefined' ? defaultValue : this[0];
};
Array.prototype.first = function () {
    return this[0];
};
Array.prototype.last = function () {
    return this[this.length - 1];
};
Array.prototype.distinct = function () {
    return this.reduce(function (result, next) { return result.indexOf(next) < 0 ? result.concat([next]) : result; }, []);
};
Array.prototype.flatten = function () {
    return this.reduce(function (result, next) {
        return result.concat(next);
    }, []);
};
Array.prototype.flatMap = function (func) {
    var results = [];
    this.forEach(function (x, y, z) {
        var temp = func(x, y, z);
        results = results.concat(temp);
    });
    return results;
};
Array.prototype.removeFirst = function (value) {
    var index = this.indexOf(value);
    if (index > -1) {
        this.splice(index, 1);
    }
    return this;
};
Array.prototype.unique = function () {
    var hash = {}, result = [];
    this.forEach(function (item) {
        if (!hash.hasOwnProperty(item)) {
            hash[item] = true;
            result.push(item);
        }
    });
    return result;
};
Array.prototype.diff = function (array_to_compare) {
    return this.filter(function (el) { return array_to_compare.indexOf(el) < 0; });
};
Array.prototype.getById = function (id) {
    var result = this.filter(function (x) { return x.id == id; });
    console.log(result);
    return result.length == 1 ? result.first() : null;
};
Array.prototype.getByField = function (value, field) {
    var result = this.filter(function (x) { return x[field] == value; });
    return result.length == 1 ? result.first() : null;
};
String.prototype.replaceAt = function (index, character) {
    return this.substr(0, index) + character + this.substr(index + character.length);
};
String.prototype.toCamelCase = function () {
    return this.replace(/^([A-Z])|[\s-_](\w)/g, function (match, p1, p2, offset) {
        if (p2)
            return p2.toUpperCase();
        return p1.toLowerCase();
    });
};
String.prototype.reverse = function () {
    return this.split('').reverse().join('');
};

var finadai;
(function (finadai) {
    var models;
    (function (models) {
        var proxy;
        (function (proxy) {
            function getSaldoTotal(info) {
                if (angular.isArray(info.Saldo)) {
                    return info.Saldo[0].SaldoBalance;
                }
                return info.Saldo.SaldoBalance;
            }
            proxy.getSaldoTotal = getSaldoTotal;
        })(proxy = models.proxy || (models.proxy = {}));
    })(models = finadai.models || (finadai.models = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var filters;
    (function (filters_1) {
        filters_1.NAME = 'finadai.filters';
        function yesnoFilter() {
            return function (input) {
                return input ? 'Si' : 'No';
            };
        }
        function sumFilter() {
            return function (input, index) {
                if (!angular.isArray(input))
                    return 0;
                return input.reduce(function (acum, item) { return acum + item[index]; }, 0);
            };
        }
        function nl2brFilter() {
            return function (data) {
                if (!data)
                    return data;
                return data.replace(/\n\r?/g, '<br />');
            };
        }
        function commasFilter() {
            return function (data, index) {
                return data.map(function (x) { return x[index]; }).join(', ');
            };
        }
        function metaFilter($filter) {
            return function (data, key, separator) {
                separator = separator || '<br />';
                var matches = data.filter(function (x) { return x.key == key; });
                if (matches.length > 0) {
                    return matches[0].value.map(function (x) { return $filter('date')(x._date, 'dd.MMM.yyyy'); }).join(separator);
                }
                return '';
            };
        }
        function momentDateFilter() {
            return function (input, format) {
                if (format === void 0) { format = 'D [de] MMMM [de] YYYY'; }
                if (input == "No Proporcionada")
                    return input;
                if (!input)
                    return input;
                return moment(input).format(format);
            };
        }
        function direccionFilter() {
            return function (input) {
                if (!input)
                    return '';
                return "".concat(input.CalleNumero, "  ").concat(input.Colonia, ", ").concat(input.Municipio, ", ").concat(input.Estado, ", CP ").concat(input.CodigoPostal);
            };
        }
        function adeudoCreditoFilter() {
            return function (input) {
                if (!input)
                    return 0;
                return parseFloat(input.Capital) + parseFloat(input.InteresesMoratorios) + parseFloat(input.InteresesOrdinarios) + parseFloat(input.Accesorios);
            };
        }
        function run() {
            var filters = angular.module(filters_1.NAME, []);
            filters.filter('yesno', yesnoFilter);
            filters.filter('sum', sumFilter);
            filters.filter('nl2br', nl2brFilter);
            filters.filter('commas', commasFilter);
            filters.filter('meta', metaFilter);
            filters.filter('momentDate', momentDateFilter);
            filters.filter('direccion', direccionFilter);
            filters.filter('adeudoCredito', adeudoCreditoFilter);
        }
        filters_1.run = run;
    })(filters = finadai.filters || (finadai.filters = {}));
})(finadai || (finadai = {}));
finadai.filters.run();

var finadai;
(function (finadai) {
    var directives;
    (function (directives) {
        function permissionRequiredDirective(authService) {
            return {
                restrict: 'A',
                link: function (scope, element, atts) {
                    authService.isLoggedIn().then(function (response) {
                        var results = response.operations.filter(function (item) { return (atts.permissionRequired.split(',').indexOf(item) >= 0); });
                        if (results.length == 0) {
                            element.remove();
                        }
                    });
                }
            };
        }
        directives.permissionRequiredDirective = permissionRequiredDirective;
        function notHasPermissionDirective(authService) {
            return {
                restrict: 'A',
                link: function (scope, element, atts) {
                    authService.isLoggedIn().then(function (response) {
                        var results = response.operations.filter(function (item) { return (atts.notHasPermission.split(',').indexOf(item) >= 0); });
                        if (results.length > 0) {
                            element.remove();
                        }
                    });
                }
            };
        }
        directives.notHasPermissionDirective = notHasPermissionDirective;
    })(directives = finadai.directives || (finadai.directives = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var directives;
    (function (directives) {
        function compareToDirective() {
            return {
                require: 'ngModel',
                scope: {
                    comparer: '=compareTo'
                },
                link: function (scope, element, atts, ngModel) {
                    ngModel.$validators.compareTo = function (modelValue) {
                        return modelValue == scope.comparer;
                    };
                    scope.$watch("comparer", function () {
                        ngModel.$validate();
                    });
                }
            };
        }
        directives.compareToDirective = compareToDirective;
    })(directives = finadai.directives || (finadai.directives = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var directives;
    (function (directives_1) {
        directives_1.NAME = 'finadai.directives';
        function run() {
            var directives = angular.module(directives_1.NAME, []);
            directives.directive('compareTo', directives_1.compareToDirective);
            directives.directive('permissionRequired', directives_1.permissionRequiredDirective);
            directives.directive('notHasPermission', directives_1.notHasPermissionDirective);
        }
        directives_1.run = run;
    })(directives = finadai.directives || (finadai.directives = {}));
})(finadai || (finadai = {}));
finadai.directives.run();

var finadai;
(function (finadai) {
    var services;
    (function (services) {
        var NegotiationsService = /** @class */ (function () {
            function NegotiationsService(proxifier, $http, $q, $filter) {
                this.proxifier = proxifier;
                this.$http = $http;
                this.$q = $q;
                this.$filter = $filter;
                this.paymentTypes = null;
            }
            NegotiationsService.prototype.getPaymentTypes = function () {
                var _this = this;
                var defer = this.$q.defer();
                if (this.paymentTypes != null) {
                    defer.resolve(this.paymentTypes);
                }
                else {
                    this.$http.get([this.proxifier(), 'finadai', 'payment_types'].join('/')).then(function (response) {
                        _this.paymentTypes = response.data.data;
                        defer.resolve(_this.paymentTypes);
                    });
                }
                return defer.promise;
            };
            NegotiationsService.prototype.getAvailablePaymentTypes = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'payment_types', 'get'].join('/'), data);
            };
            NegotiationsService.prototype.get = function (id, filters) {
                if (angular.isUndefined(id) || id == null) {
                    filters.gtd_created_at = this.$filter('date')(filters.gtd_created_at, 'yyyy-MM-dd');
                    filters.ltd_created_at = this.$filter('date')(filters.ltd_created_at, 'yyyy-MM-dd');
                    return this.$http.get([this.proxifier(), 'finadai', 'negotiations'].join('/'), { params: filters });
                }
                return this.$http.get([this.proxifier(), 'finadai', 'negotiations', id].join('/'), { params: { with: 'credits,payment_type,customer,granter,meta' } });
            };
            NegotiationsService.prototype.getCredit = function (id) {
                return this.$http.get([this.proxifier(), 'finadai', 'credits', id].join('/'), { params: { with: 'customer' } });
            };
            NegotiationsService.prototype.getCredits = function (params) {
                return this.$http.get([this.proxifier(), 'finadai', 'credits'].join('/'), { params: params });
            };
            NegotiationsService.prototype.getCoAcredits = function (loan_id, client_id) {
                return this.$http.post([this.proxifier(), 'finadai', 'credits', 'co_accredits'].join('/'), { client_id: client_id, loan_id: loan_id });
            };
            NegotiationsService.prototype.saveCredit = function (id, data) {
                return this.$http.put([this.proxifier(), 'finadai', 'credits', id].join('/'), data);
            };
            NegotiationsService.prototype.cancelNegotiation = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'cancel_negotiation'].join('/'), data);
            };
            NegotiationsService.prototype.save = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'negotiations'].join('/'), data);
            };
            NegotiationsService.prototype.saveNotAuthorized = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'not_authorize'].join('/'), data);
            };
            NegotiationsService.prototype.acceptTerms = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'accept_terms'].join('/'), data);
            };
            NegotiationsService.prototype.download = function (filters) {
                return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'excel'].join('/'), {}, { params: filters });
            };
            NegotiationsService.prototype.send = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'send_email'].join('/'), data);
            };
            NegotiationsService.prototype.getGranters = function () {
                return this.$http.get([this.proxifier(), 'finadai', 'granters', 'list'].join('/'));
            };
            NegotiationsService.prototype.findCredit = function (data) {
                var config = { ignoreBEValidation: true };
                return this.$http.post([this.proxifier(), 'finadai', 'credits', 'search'].join('/'), data, config);
            };
            NegotiationsService.prototype.generatePayments = function (data) {
                var config = { ignoreBEValidation: true };
                return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'create_payments'].join('/'), data, config);
            };
            NegotiationsService.prototype.authorize = function (negotiation_id) {
                return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'authorize'].join('/'), { negotiation_id: negotiation_id });
            };
            NegotiationsService.prototype.changeNoteStatus = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'negotiations', 'note_status'].join('/'), data);
            };
            NegotiationsService.instanceName = 'negotiationsService';
            return NegotiationsService;
        }());
        services.NegotiationsService = NegotiationsService;
    })(services = finadai.services || (finadai.services = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var services;
    (function (services) {
        var PaymentsService = /** @class */ (function () {
            function PaymentsService(proxifier, $http, $q, $filter) {
                this.proxifier = proxifier;
                this.$http = $http;
                this.$q = $q;
                this.$filter = $filter;
            }
            PaymentsService.prototype.getAll = function (params) {
                return this.$http.get([this.proxifier(), 'finadai', 'payments'].join('/'), { params: params });
            };
            PaymentsService.prototype.downloadActivities = function (filters) {
                return this.$http.post([this.proxifier(), 'finadai', 'payments', 'excel'].join('/'), {}, { params: filters });
            };
            PaymentsService.instanceName = 'paymentsService';
            return PaymentsService;
        }());
        services.PaymentsService = PaymentsService;
    })(services = finadai.services || (finadai.services = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var services;
    (function (services) {
        var CustomersService = /** @class */ (function () {
            function CustomersService(proxifier, $http) {
                this.proxifier = proxifier;
                this.$http = $http;
            }
            CustomersService.prototype.register = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', 'validate'].join('/'), data);
            };
            CustomersService.prototype.validate = function (token) {
                return this.$http.get([this.proxifier(), 'finadai', 'customers', 'confirm', token].join('/'));
            };
            CustomersService.prototype.search = function (customer_number) {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', 'search'].join('/'), { search_number: customer_number });
            };
            CustomersService.prototype.get = function (customer_number, trash) {
                var config = {
                    transformResponse: function (_data, headers, status) {
                        var data = services.util.PropertiesTransformInterceptor(_data, headers, status);
                        if (status == 200) {
                            if (angular.isDefined(data.data.phones)) {
                                angular.forEach(data.data.phones, function (phone) {
                                    switch (phone.type) {
                                        case 'Celular':
                                            phone.type_icon = 'smartphone';
                                            break;
                                        default:
                                            phone.type_icon = 'local_phone';
                                            break;
                                    }
                                });
                            }
                        }
                        return data;
                    },
                    params: {
                        with: 'locations,emails,phones,negotiations,credits,negotiations.payment_type,negotiations.granter,activities,media,references.relationship'
                    }
                };
                if (trash) {
                    config.params.with_trash = 1;
                }
                return this.$http.get([this.proxifier(), 'finadai', 'customers', customer_number].join('/'), config);
            };
            CustomersService.prototype.getInfo = function () {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', 'get_info'].join('/'), {});
            };
            CustomersService.prototype.delete = function (id, entity, customerId) {
                if (angular.isDefined(entity)) {
                    return this.$http.delete([this.proxifier(), 'finadai', 'customers', customerId, entity, id].join('/'));
                }
                return this.$http.delete([this.proxifier(), 'finadai', 'customers', id].join('/'));
            };
            CustomersService.prototype.deleteFile = function (id, customer_id) {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', 'de_attach_file'].join('/'), {
                    media_id: id,
                    customer_id: customer_id
                });
            };
            CustomersService.prototype.save = function (data, id, entity, customerId) {
                if (id) {
                    if (entity != null) {
                        return this.$http.put([this.proxifier(), 'finadai', 'customers', customerId, entity, id].join('/'), data);
                    }
                    return this.$http.put([this.proxifier(), 'finadai', 'customers', id].join('/'), data);
                }
                else {
                    if (entity != null) {
                        return this.$http.post([this.proxifier(), 'finadai', 'customers', customerId, entity].join('/'), data);
                    }
                    return this.$http.post([this.proxifier(), 'finadai', 'customers'].join('/'), data);
                }
            };
            CustomersService.prototype.getActivityTypes = function () {
                return this.$http.get([this.proxifier(), 'finadai', 'activity_types'].join('/'));
            };
            CustomersService.prototype.getRelationshipTypes = function () {
                return this.$http.get([this.proxifier(), 'finadai', 'relationships'].join('/'));
            };
            CustomersService.prototype.getCreditStatus = function () {
                return this.$http.get([this.proxifier(), 'finadai', 'credit_status'].join('/'));
            };
            CustomersService.prototype.recordActivity = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'activities'].join('/'), data);
            };
            CustomersService.prototype.sendInvite = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', 'invitation'].join('/'), data);
            };
            CustomersService.prototype.deactivateCustomer = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', 'inactive_customer'].join('/'), data);
            };
            CustomersService.prototype.activateCustomer = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', 'active_customer'].join('/'), data);
            };
            CustomersService.prototype.changeStatusCredit = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'credits', 'inactive'].join('/'), data);
            };
            CustomersService.prototype.getPendingNegotiations = function () {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', 'pending_negotiations'].join('/'), {});
            };
            CustomersService.prototype.getCauses = function () {
                return this.$http.get([this.proxifier(), 'finadai', 'get_causes'].join('/'));
            };
            CustomersService.prototype.updateName = function (customer_id, data) {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', customer_id, 'edit_name'].join('/'), data);
            };
            CustomersService.prototype.getActivities = function (params) {
                return this.$http.get([this.proxifier(), 'finadai', 'activities'].join('/'), { params: params });
            };
            CustomersService.prototype.downloadActivities = function (filters) {
                return this.$http.post([this.proxifier(), 'finadai', 'activities', 'excel_cron'].join('/'), {}, { params: filters });
            };
            CustomersService.prototype.proxySearch = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/search"), data);
            };
            CustomersService.prototype.proxyNewSearch = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/new_search"), data);
            };
            CustomersService.prototype.proxySearchCredit = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/credit"), data);
            };
            CustomersService.prototype.proxySaveManualNegotiation = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/save_manual_negotiation"), data);
            };
            CustomersService.prototype.proxyRegister = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/create_user"), data);
            };
            CustomersService.prototype.proxyValidate = function (token) {
                return this.$http.get("".concat(this.proxifier(), "/finadai/proxy/validate_user/").concat(token));
            };
            CustomersService.prototype.proxyGetCustomer = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/customer"), data);
            };
            CustomersService.prototype.proxyGetNegotiation = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/negotiation"), data);
            };
            CustomersService.prototype.proxySearchNegotiation = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/negotiation_search"), data);
            };
            CustomersService.prototype.proxyPaymentOptions = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/default_payments"), data);
            };
            CustomersService.prototype.proxySaveNegotiation = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/save_negotiation"), data);
            };
            CustomersService.prototype.proxySaveCustomer = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/customer_update"), data);
            };
            CustomersService.prototype.proxyAccessToken = function (token) {
                return this.$http.get("".concat(this.proxifier(), "/finadai/proxy/access_token/").concat(token));
            };
            CustomersService.prototype.proxyCancelNegotiation = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/cancel_negotiation"), data);
            };
            CustomersService.prototype.proxyUpdateCustomerAdmin = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/admin_update"), data);
            };
            CustomersService.prototype.proxyValidateCellphone = function (cellphone) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/validate_phone"), cellphone);
            };
            CustomersService.prototype.proxyCreateReferenceAdmin = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/admin_create_reference"), data);
            };
            CustomersService.prototype.proxyChangeSICCustomerAdmin = function (data) {
                return this.$http.post("".concat(this.proxifier(), "/finadai/proxy/admin_change_sic"), data);
            };
            CustomersService.prototype.proxyGetOriginator = function () {
                return this.$http.get("".concat(this.proxifier(), "/finadai/proxy/originators"));
            };
            CustomersService.instanceName = 'customersService';
            return CustomersService;
        }());
        services.CustomersService = CustomersService;
    })(services = finadai.services || (finadai.services = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var services;
    (function (services) {
        var FilesService = /** @class */ (function () {
            function FilesService($http, proxifier, $httpParamSerializer) {
                this.$http = $http;
                this.proxifier = proxifier;
                this.$httpParamSerializer = $httpParamSerializer;
            }
            FilesService.prototype.upload = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'customers', 'file'].join('/'), data);
            };
            FilesService.instanceName = 'filesService';
            return FilesService;
        }());
        services.FilesService = FilesService;
    })(services = finadai.services || (finadai.services = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var services;
    (function (services) {
        var AgentsService = /** @class */ (function () {
            function AgentsService($http, proxifier, $httpParamSerializer) {
                this.$http = $http;
                this.proxifier = proxifier;
                this.$httpParamSerializer = $httpParamSerializer;
            }
            AgentsService.prototype.save = function (data, id) {
                // data = this.$httpParamSerializer(data)
                if (angular.isDefined(data.id))
                    id = data.id;
                if (angular.isUndefined(id)) {
                    return this.$http.post([this.proxifier(), 'finadai', 'agents'].join('/'), data);
                }
                return this.$http.put([this.proxifier(), 'finadai', 'agents', id].join('/'), data);
            };
            AgentsService.prototype.get = function (id) {
                if (angular.isUndefined(id)) {
                    return this.$http.get([this.proxifier(), 'finadai', 'agents'].join('/'), { params: { page: 1, limit: 2000 } });
                }
                return this.$http.get([this.proxifier(), 'finadai', 'agents', id].join('/'));
            };
            AgentsService.prototype.remove = function (id) {
                return this.$http.delete([this.proxifier(), 'finadai', 'agents', id].join('/'));
            };
            AgentsService.instanceName = "agentsService";
            return AgentsService;
        }());
        services.AgentsService = AgentsService;
    })(services = finadai.services || (finadai.services = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var services;
    (function (services) {
        var GrantersService = /** @class */ (function () {
            function GrantersService($http, proxifier, $httpParamSerializer) {
                this.$http = $http;
                this.proxifier = proxifier;
                this.$httpParamSerializer = $httpParamSerializer;
            }
            GrantersService.prototype.save = function (data, id) {
                // data = this.$httpParamSerializer(data)
                if (angular.isDefined(data.id))
                    id = data.id;
                if (angular.isUndefined(id)) {
                    return this.$http.post([this.proxifier(), 'finadai', 'granters'].join('/'), data);
                }
                return this.$http.put([this.proxifier(), 'finadai', 'granters', id].join('/'), data);
            };
            GrantersService.prototype.get = function (id) {
                if (angular.isUndefined(id)) {
                    return this.$http.get([this.proxifier(), 'finadai', 'granters'].join('/'), { params: { page: 1, limit: 2000 } });
                }
                return this.$http.get([this.proxifier(), 'finadai', 'granters', id].join('/'));
            };
            GrantersService.prototype.remove = function (id) {
                return this.$http.delete([this.proxifier(), 'finadai', 'granters', id].join('/'));
            };
            GrantersService.instanceName = "grantersService";
            return GrantersService;
        }());
        services.GrantersService = GrantersService;
    })(services = finadai.services || (finadai.services = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var services;
    (function (services) {
        var AuthService = /** @class */ (function () {
            function AuthService($http, proxifier, $q, $localStorage, $injector) {
                this.$http = $http;
                this.proxifier = proxifier;
                this.$q = $q;
                this.$localStorage = $localStorage;
                this.$injector = $injector;
                this.currentUser = null;
            }
            AuthService.prototype.isWhiteListStates = function (state) {
                return ['login', 'changePassword', 'forgotPassword', 'resetPassword', 'register', 'registerSuccess', 'findYourCredit', 'payYourCredit', 'validateAccount', 'accessAccount'].indexOf(state) >= 0;
            };
            AuthService.prototype.isLoggedIn = function () {
                var _this = this;
                var defer = this.$q.defer();
                if (this.currentUser == null) {
                    this.$http.post([this.proxifier(), 'auth', 'me'].join('/'), {}).then(function (response) {
                        _this.currentUser = response.data.user;
                        switch (_this.currentUser.privilege) {
                            case "1":
                                _this.currentUser.privilege = 'admin';
                                break;
                            case "2":
                                _this.currentUser.privilege = 'agent';
                                break;
                            case "3":
                                _this.currentUser.privilege = 'customer';
                                break;
                            case "4":
                                _this.currentUser.privilege = 'operational';
                                break;
                        }
                        _this.currentUser.states = ['app.dashboard', 'app.notFound'];
                        angular.forEach(_this.currentUser.operations, function (item) {
                            switch (item) {
                                case 'login':
                                    _this.currentUser.states.push('login');
                                    break;
                                case 'validateAccount':
                                    _this.currentUser.states.push('validateAccount', 'app.login');
                                    break;
                                case 'accessAccount':
                                    _this.currentUser.states.push('accessAccount', 'app.login');
                                    break;
                                case 'reset_password':
                                    _this.currentUser.states.push('app.changePassword', 'changePassword');
                                    break;
                                case 'activities_index':
                                    _this.currentUser.states.push('app.activities.list');
                                    break;
                                case 'activities_show':
                                    _this.currentUser.states.push('app.activities.detail');
                                    break;
                                case 'agents_index':
                                    _this.currentUser.states.push('app.agents', 'app.agents.list');
                                    break;
                                case 'agents_store':
                                    _this.currentUser.states.push('app.agents.create');
                                    break;
                                case 'agents_update':
                                    _this.currentUser.states.push('app.agents.detail');
                                    break;
                                case 'granters_index':
                                    _this.currentUser.states.push('app.granters', 'app.granters.list');
                                    break;
                                case 'granters_store':
                                    _this.currentUser.states.push('app.granters.create');
                                    break;
                                case 'granters_update':
                                    _this.currentUser.states.push('app.granters.detail');
                                    break;
                                case 'customers_search':
                                    _this.currentUser.states.push('app.customers.detail', 'app.search.results');
                                    break;
                                case 'customers_upload_file':
                                    _this.currentUser.states.push('app.upload');
                                    break;
                                case 'negotiations_index':
                                    _this.currentUser.states.push('app.negotiations', 'app.negotiations.list');
                                    _this.currentUser.states.push('app.negotiations.paid', 'app.negotiations.paid');
                                    break;
                                case 'negotiations_show':
                                    _this.currentUser.states.push('app.negotiations.create', 'app.negotiations.detail');
                                    break;
                                case 'customers_get_info':
                                    _this.currentUser.states.push('app.customers.profile');
                                    break;
                                case 'logs_index':
                                    _this.currentUser.states.push('app.customers.timeline');
                                    break;
                                case 'maps_view':
                                    _this.currentUser.states.push('app.map');
                                    break;
                                case 'reports_payments':
                                    _this.currentUser.states.push('app.payments', 'app.payments.list');
                                    break;
                                case 'reports_activities':
                                    _this.currentUser.states.push('app.activities', 'app.activities.report');
                                    break;
                                case 'customers_cancel_negotiation':
                                    _this.currentUser.states.push('app.customers.cancel_negotiation');
                                    break;
                                case 'admin_create_negotiation':
                                    _this.currentUser.states.push('app.admin.create');
                                    break;
                                case 'admin_search_customer':
                                    _this.currentUser.states.push('app.admin.search');
                                    break;
                                case 'admin_find_negotiation':
                                    _this.currentUser.states.push('app.admin.find_negotiation');
                                    break;
                                case 'admin_cancel_negotiation':
                                    _this.currentUser.states.push('app.admin.cancel_negotiation');
                                    break;
                                case 'admin_update_customer':
                                    _this.currentUser.states.push('app.admin.update');
                                    break;
                                case 'admin_find_customer':
                                    _this.currentUser.states.push('app.admin.find');
                                    break;
                                case 'admin_create_single_reference':
                                    _this.currentUser.states.push('app.admin.create_reference');
                                    break;
                                case 'admin_change_sic_customer':
                                    _this.currentUser.states.push('app.admin.change_sic');
                                    break;
                            }
                        });
                        defer.resolve(_this.currentUser);
                    });
                }
                else {
                    defer.resolve(this.currentUser);
                }
                return defer.promise;
            };
            AuthService.prototype.changeDefaultPassword = function (data) {
                return this.$http.post([this.proxifier(), 'finadai', 'agents', 'change_default_password'].join('/'), data);
            };
            AuthService.prototype.sendInstructions = function (data) {
                return this.$http.post([this.proxifier(), 'password', 'email'].join('/'), data);
            };
            AuthService.prototype.resetPassword = function (data) {
                return this.$http.post([this.proxifier(), 'password', 'reset'].join('/'), data);
            };
            AuthService.prototype.changePassword = function (data) {
                return this.$http.post([this.proxifier(), 'auth', 'change_password'].join('/'), data);
            };
            AuthService.prototype.login = function (data) {
                return this.$http.post([this.proxifier(), 'auth'].join('/'), data);
            };
            AuthService.prototype.logout = function () {
                var _this = this;
                var self = this;
                return this.$http.get([this.proxifier(), 'auth'].join('/')).then(function (response) {
                    delete _this.$localStorage.apiToken;
                    _this.currentUser = null;
                    return response;
                });
            };
            AuthService.instanceName = "authService";
            return AuthService;
        }());
        services.AuthService = AuthService;
        var ignoreTokenUrls = [
            { method: "POST", url: "finadai/proxy/create_user" },
            { method: "GET", url: "finadai/proxy/validate_user" },
            { method: "POST", url: "finadai/proxy/search" },
            { method: "POST", url: "finadai/proxy/new_search" },
            { method: "POST", url: "password/email" },
            { method: "POST", url: "password/reset" },
        ];
        services.authHttpInterceptorName = "authHttpInterceptor";
        function AuthHttpInterceptor($injector, $q, $rootScope, $localStorage) {
            return {
                request: function (config) {
                    var urlMatch = ignoreTokenUrls.filter(function (x) { return x.method == config.method && config.url.indexOf(x.url) >= 0; });
                    if (urlMatch.length == 0) {
                        config.headers.Authorization = $localStorage.apiToken;
                        console.log("url_auth", config.url);
                    }
                    return config;
                },
                responseError: function (rejection) {
                    if (rejection.status == 401) {
                        $rootScope.stateChangeBypass = true;
                        $rootScope.$broadcast('preloader:hide');
                        $injector.get('$state').go('login');
                    }
                    return $q.reject(rejection);
                }
            };
        }
        services.AuthHttpInterceptor = AuthHttpInterceptor;
    })(services = finadai.services || (finadai.services = {}));
})(finadai || (finadai = {}));

var finadai;
(function (finadai) {
    var services;
    (function (services) {
        var util;
        (function (util) {
            util.NAME = "utilsService";
            function proxifier($location) {
                return function (withApi, apiVersion) {
                    var api = '/api/';
                    apiVersion = apiVersion || 'v1';
                    if (angular.isDefined(withApi) && withApi === false) {
                        api = '';
                        apiVersion = '';
                    }
                    switch ($location.host()) {
                        case 'finadaiapp.test':
                            return 'http://finadai.api' + api + apiVersion;
                        case 'finadai.app':
                            return 'http://finadai.api' + api + apiVersion;
                        case 'admin.finadai.local':
                            return '//api.finadai.local' + api + apiVersion;
                        case 'finadaiapp.app':
                            return 'http://finadai.app' + api + apiVersion;
                        case 'app.quam.mx':
                            return 'https://quam-api-prod-8g2we.ondigitalocean.app' + api + apiVersion;
                        case 'holiday.quam.mx':
                            return 'http://api.quam.mx' + api + apiVersion;
                        case 'testholiday.quam.mx':
                            return 'http://testapi.quam.mx' + api + apiVersion;
                        case 'testapp.quam.mx':
                            return 'https://quam-qa-app-e4snd.ondigitalocean.app' + api + apiVersion;
                        case 'hsbcapp.test':
                            return 'http://hsbc.api' + api + apiVersion;
                        case '127.0.0.1':
                            return 'http://localhost:8088' + api + apiVersion;
                        case 'localhost':
                            return 'http://localhost:8088' + api + apiVersion;
                        case 'quam-app-qa.netlify.app':
                            return 'https://quam-qa-app-e4snd.ondigitalocean.app' + api + apiVersion;
                        case 'quam-app.netlify.app':
                            return 'https://quam-api-prod-8g2we.ondigitalocean.app' + api + apiVersion;
                    }
                };
            }
            function notify($mdToast) {
                return function (message, type, delay) {
                    if (angular.isUndefined(type)) {
                        type = 'success';
                    }
                    if (angular.isUndefined(delay)) {
                        delay = 8000;
                    }
                    $mdToast.show({
                        controller: function ($mdToast, $scope) {
                            $scope.closeToast = function () { return $mdToast.hide(); };
                        },
                        template: '<md-toast class="md-toast-' + type + '"><span flex>' + message + '</span> <md-button ng-click="closeToast()" translate> Cerrar </md-button> </md-toast>',
                        hideDelay: delay,
                        position: 'top right'
                    });
                };
            }
            function confirm($mdDialog) {
                return function (title, content, target, okText, cancelText) {
                    okText = okText || 'si';
                    cancelText = cancelText || 'no';
                    var confirmOpt = $mdDialog.confirm()
                        .title(title)
                        .textContent(content)
                        .targetEvent(target)
                        .ok(okText)
                        .cancel(cancelText);
                    return $mdDialog.show(confirmOpt);
                };
            }
            function toParams(obj) {
                var params = [];
                for (var key in obj) {
                    params.push(key + '=' + encodeURIComponent(obj[key]));
                }
                return params.join('&');
            }
            util.toParams = toParams;
            function BackendValidationInterceptor($injector, $q) {
                return {
                    responseError: function (rejection) {
                        var config = rejection.config;
                        if (angular.isUndefined(config.ignoreBEValidation) && !config.ignoreBEValidation) {
                            if (rejection.status == 412 || rejection.status == 422 || rejection.status == 400) {
                                var errorsMessage = angular.isDefined(rejection.data.message) ? rejection.data.message : "Error";
                                var output = '<span class="block">' + errorsMessage + '</span>';
                                if (typeof rejection.data.errors !== "string") {
                                    output = '<span class="block mt10">' + errorsMessage + '</span>';
                                    output += '<ol>';
                                    for (var field in rejection.data.errors) {
                                        for (var errorType in rejection.data.errors[field]) {
                                            var errorString = angular.isDefined(rejection.data.errors[field][errorType]["error"]) ? rejection.data.errors[field][errorType]["error"] : rejection.data.errors[field][errorType];
                                            output += '<li>' + errorString + '</li>';
                                        }
                                    }
                                    output += '</ol>';
                                }
                                $injector.get('notify')(output, 'danger');
                            }
                            if (rejection.status == 403) {
                                $injector.get('notify')("Acceso no autorizado", 'danger');
                            }
                            if (rejection.status == 500) {
                                $injector.get('notify')('Ha ocurrido un error interno, favor de contactar al administrador', 'danger');
                            }
                        }
                        return $q.reject(rejection);
                    }
                };
            }
            function PropertiesTransformInterceptor(_data, headers, status) {
                function addParsedDateReturn(__item) {
                    if (__item != null && !angular.isArray(__item) && angular.isDefined(__item.date) && angular.isDefined(__item.timezone)) {
                        __item._date = window.moment(__item.date).tz(__item.timezone).toDate();
                    }
                    return __item;
                }
                function processData(__data) {
                    for (var key in __data) {
                        __data[key] = addParsedDateReturn(__data[key]);
                        if (angular.isArray(__data[key]) || angular.isObject(__data[key])) {
                            __data[key] = processData(__data[key]);
                        }
                    }
                    ;
                    return __data;
                }
                if (headers('Content-Type') == 'application/json') {
                    var data = angular.fromJson(_data);
                    var copiedData = processData(angular.copy(data));
                    return copiedData;
                }
                return _data;
            }
            util.PropertiesTransformInterceptor = PropertiesTransformInterceptor;
            util.DateShortFormatFinadai = 'dd/MMM/yyyy';
            util.DateLongFormatFinadai = "dd/MMM/yyyy',' hh:mma";
            function run() {
                var utilsService = angular.module(util.NAME, []);
                utilsService.service("backendValidationInterceptor", BackendValidationInterceptor);
                utilsService.service("proxifier", proxifier);
                utilsService.service("notify", notify);
                utilsService.service("confirm", confirm);
                utilsService.config(function ($httpProvider) {
                    $httpProvider.defaults.transformResponse = [PropertiesTransformInterceptor];
                    $httpProvider.interceptors.push("backendValidationInterceptor");
                });
                utilsService.run(function () {
                    window.moment.defineLocale('es', {
                        months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split("_"),
                        monthsShort: "Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic".split("_"),
                        weekdays: "Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado".split("_"),
                        weekdaysShort: "Dom_Lun_Mar_Mie_Jue_Vie_Sab".split("_"),
                        weekdaysMin: "Do_Lu_Ma_Mi_Ju_Vi_Sa".split("_"),
                        longDateFormat: {
                            LT: "h:mmA",
                            LTS: "h:mm:ssA",
                            L: "DD/MM/YYYY",
                            LL: "D MMMM YYYY",
                            LLL: "D MMMM YYYY LT",
                            LLLL: "dddd, D MMMM, YYYY LT"
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
                            },
                            lastDay: function () {
                                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
                            },
                            sameElse: 'L'
                        },
                        relativeTime: {
                            future: 'en %s',
                            past: 'hace %s',
                            s: 'unos segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'una hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un año',
                            yy: '%d años',
                        },
                        // ordinalParse : /\d{1,2}º/,
                        // ordinal : '%dº',
                        // in case the meridiem units are not separated around 12, then implement
                        // this function (look at locale/id.js for an example)
                        // meridiemHour : function (hour, meridiem) {
                        //     return /* 0-23 hour, given meridiem token and hour 1-12 */
                        // },
                        meridiem: function (hours, minutes, isLower) {
                            return hours < 12 ? 'am' : 'pm';
                        },
                        week: {
                            dow: 1,
                            doy: 4 // The week that contains Jan 4th is the first week of the year.
                        }
                    });
                });
            }
            util.run = run;
        })(util = services.util || (services.util = {}));
    })(services = finadai.services || (finadai.services = {}));
})(finadai || (finadai = {}));
finadai.services.util.run();

var finadai;
(function (finadai) {
    var services;
    (function (services_1) {
        services_1.NAME = "finadai.services";
        function run() {
            var services = angular.module(services_1.NAME, [
                'ngStorage',
                'ui.router',
                finadai.services.util.NAME
            ]);
            services.factory(services_1.authHttpInterceptorName, services_1.AuthHttpInterceptor);
            services.service(services_1.AuthService.instanceName, services_1.AuthService);
            services.service(services_1.AgentsService.instanceName, services_1.AgentsService);
            services.service(services_1.GrantersService.instanceName, services_1.GrantersService);
            services.service(services_1.FilesService.instanceName, services_1.FilesService);
            services.service(services_1.CustomersService.instanceName, services_1.CustomersService);
            services.service(services_1.NegotiationsService.instanceName, services_1.NegotiationsService);
            services.service(services_1.PaymentsService.instanceName, services_1.PaymentsService);
            services.config(function ($httpProvider) {
                $httpProvider.interceptors.push(services_1.authHttpInterceptorName);
                // $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
            });
        }
        services_1.run = run;
    })(services = finadai.services || (finadai.services = {}));
})(finadai || (finadai = {}));
finadai.services.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var activities;
        (function (activities) {
            var report;
            (function (report_1) {
                report_1.NAME = 'finadai.activities.report';
                var ActivitiesReportController = /** @class */ (function () {
                    function ActivitiesReportController(customersService, $filter, $scope, agentes, notify) {
                        this.customersService = customersService;
                        this.notify = notify;
                        this.loading = false;
                        this.filters = { with: 'agent.user,customer,activity_type', limit: 1000, gtd_created_at: window.moment().subtract(1, 'months').toDate(), ltd_created_at: window.moment().toDate() };
                        this.query = { order: '-created_at._date', limit: 10, page: 1 };
                        this.filters.status = 'paid';
                        this.filters.only_calls = false;
                        this.agentes = agentes.data.data;
                        this.notify = notify;
                    }
                    ActivitiesReportController.prototype.search = function () {
                        var _this = this;
                        this.loading = true;
                        var _filters = angular.copy(this.filters);
                        _filters.gtd_created_at = _filters.gtd_created_at != null ? window.moment(_filters.gtd_created_at).format('YYYY-MM-DD') : null;
                        _filters.ltd_created_at = _filters.ltd_created_at != null ? window.moment(_filters.ltd_created_at).format('YYYY-MM-DD') : null;
                        this.promise = this.customersService.getActivities(_filters).then(function (response) {
                            _this.activities = response.data.data;
                            _this.loading = false;
                            return response;
                        });
                    };
                    ActivitiesReportController.prototype.download = function () {
                        var _this = this;
                        this.loading = true;
                        var _filters = angular.copy(this.filters);
                        _filters.gtd_created_at = _filters.gtd_created_at != null ? window.moment(_filters.gtd_created_at).format('YYYY-MM-DD') : null;
                        _filters.ltd_created_at = _filters.ltd_created_at != null ? window.moment(_filters.ltd_created_at).format('YYYY-MM-DD') : null;
                        this.customersService.downloadActivities(_filters).then(function (response) {
                            _this.loading = false;
                            if (response.status == 200) {
                                _this.notify('El archivo ha sido agregado y será procesado en un momento.');
                            }
                        });
                    };
                    return ActivitiesReportController;
                }());
                function run() {
                    var report = angular.module(report_1.NAME, []);
                    report.controller('ActivitiesReportController', ActivitiesReportController);
                }
                report_1.run = run;
            })(report = activities.report || (activities.report = {}));
        })(activities = app.activities || (app.activities = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.activities.report.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var activities;
        (function (activities_1) {
            activities_1.NAME = 'finadai.app.activities';
            function ConfigRoutes($stateProvider, $urlRouterProvider) {
                $urlRouterProvider.when('/activities', '/activities/report');
                $stateProvider
                    .state('app.activities', {
                    template: '<div ui-view></div>',
                    url: '/activities',
                })
                    .state('app.activities.report', {
                    templateUrl: 'app/activities/report/report.tpl.html',
                    controller: 'ActivitiesReportController',
                    controllerAs: 'vm',
                    url: '/report',
                    resolve: {
                        agentes: function (agentsService) { return agentsService.get(); }
                    }
                });
            }
            function run() {
                var activities = angular.module(activities_1.NAME, [
                    finadai.app.activities.report.NAME
                ]);
                activities.config(ConfigRoutes);
            }
            activities_1.run = run;
        })(activities = app.activities || (app.activities = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.activities.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var payments;
        (function (payments) {
            var list;
            (function (list_1) {
                list_1.NAME = 'finadai.payments.list';
                var PaymentsListController = /** @class */ (function () {
                    function PaymentsListController(paymentsService, $filter, $scope) {
                        this.paymentsService = paymentsService;
                        this.paymentStatus = ['payment_pending', 'declined', 'expired', 'paid', 'refunded', 'partially_refunded', 'charged_back', 'pre_authorized', 'voided'];
                        this.filters = { with: '', limit: 1000, gtd_paid_at: window.moment().subtract(1, 'days').toDate(), ltd_paid_at: window.moment().toDate() };
                        this.query = { order: '-created_at._date', limit: 10, page: 1 };
                        this.filters.status = 'paid';
                    }
                    PaymentsListController.prototype.search = function () {
                        var _this = this;
                        var _filters = angular.copy(this.filters);
                        _filters.gtd_paid_at = _filters.gtd_paid_at != null ? window.moment(_filters.gtd_paid_at).format('YYYY-MM-DD') : null;
                        _filters.ltd_paid_at = _filters.ltd_paid_at != null ? window.moment(_filters.ltd_paid_at).format('YYYY-MM-DD') : null;
                        _filters.with = "negotiation,negotiation.customer";
                        this.promise = this.paymentsService.getAll(_filters).then(function (response) {
                            _this.payments = response.data.data;
                            return response;
                        });
                    };
                    PaymentsListController.prototype.download = function () {
                        var _filters = angular.copy(this.filters);
                        _filters.gtd_paid_at = _filters.gtd_paid_at != null ? window.moment(_filters.gtd_paid_at).format('YYYY-MM-DD') : null;
                        _filters.ltd_paid_at = _filters.ltd_paid_at != null ? window.moment(_filters.ltd_paid_at).format('YYYY-MM-DD') : null;
                        this.paymentsService.downloadActivities(_filters).then(function (response) {
                            if (response.status == 200) {
                                window.location.href = response.data.url;
                            }
                        });
                    };
                    return PaymentsListController;
                }());
                function run() {
                    var list = angular.module(list_1.NAME, []);
                    list.controller('PaymentsListController', PaymentsListController);
                }
                list_1.run = run;
            })(list = payments.list || (payments.list = {}));
        })(payments = app.payments || (app.payments = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.payments.list.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var payments;
        (function (payments_1) {
            payments_1.NAME = 'finadai.app.payments';
            function ConfigRoutes($stateProvider, $urlRouterProvider) {
                $urlRouterProvider.when('/payments', '/payments/list');
                $stateProvider
                    .state('app.payments', {
                    template: '<div ui-view></div>',
                    url: '/payments',
                })
                    .state('app.payments.list', {
                    templateUrl: 'app/payments/list/list.tpl.html',
                    controller: 'PaymentsListController',
                    controllerAs: 'vm',
                    url: '/list'
                });
            }
            function run() {
                var payments = angular.module(payments_1.NAME, [
                    finadai.app.payments.list.NAME
                ]);
                payments.config(ConfigRoutes);
            }
            payments_1.run = run;
        })(payments = app.payments || (app.payments = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.payments.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var negotiations;
        (function (negotiations) {
            var list;
            (function (list_1) {
                list_1.NAME = 'finadai.negotiations.list';
                function NegotiationsListController($scope, negotiationsService, agents, $filter) {
                    $scope.agents = agents.data.data;
                    $scope.filters = { with: 'credits,customer,agent,meta,payment_type' };
                    $scope.query = {
                        order: '-created_at._date',
                        limit: 10,
                        page: 1
                    };
                    $scope.reload = function () {
                        $scope.promise = negotiationsService.get(null, angular.copy($scope.filters)).then(function (response) {
                            $scope.negotiations = response.data;
                            return response;
                        });
                    };
                    $scope.download = function () {
                        negotiationsService.download($scope.filters).then(function (response) {
                            if (response.status == 200) {
                                window.location = response.data.url;
                            }
                        });
                    };
                    $scope.$watchCollection('filters', function (newNames, oldNames) {
                        $scope.reload();
                    });
                }
                function run() {
                    var list = angular.module(list_1.NAME, []);
                    list.controller('NegotiationsListController', NegotiationsListController);
                }
                list_1.run = run;
            })(list = negotiations.list || (negotiations.list = {}));
        })(negotiations = app.negotiations || (app.negotiations = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.negotiations.list.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var negotiations;
        (function (negotiations) {
            var paid;
            (function (paid) {
                paid.NAME = 'finadai.negotiations.paid';
                function NegotiationsPaidController($scope, notify, negotiationsService, agents, $filter) {
                    $scope.agents = agents.data.data;
                    $scope.filters = { with: 'credits,credits.loan_type,customer,agent,meta,payment_type', 'only_paid': 1 };
                    $scope.noteStatus = [
                        {
                            "id": 0,
                            "name": "Pendiente",
                        },
                        {
                            "id": 1,
                            "name": "Entregado",
                        }
                    ];
                    $scope.query = {
                        order: '-created_at._date',
                        limit: 10,
                        page: 1
                    };
                    $scope.reload = function () {
                        $scope.promise = negotiationsService.get(null, angular.copy($scope.filters)).then(function (response) {
                            $scope.negotiations = response.data;
                            return response;
                        });
                    };
                    $scope.download = function () {
                        negotiationsService.download($scope.filters).then(function (response) {
                            if (response.status == 200) {
                                // window.location = response.data.url;
                            }
                        });
                    };
                    $scope.changeNoteStatus = function (negotiation) {
                        if (negotiation.note_status != negotiation.new_note_status) {
                            negotiationsService.changeNoteStatus({ negotiation_id: negotiation.id, note_status: negotiation.new_note_status }).then(function (response) {
                                notify('Estado de Pagare Actualizado.');
                            });
                        }
                    };
                    $scope.$watchCollection('filters', function (newNames, oldNames) {
                        $scope.reload();
                    });
                }
                function run() {
                    var list = angular.module(paid.NAME, []);
                    list.controller('NegotiationsPaidController', NegotiationsPaidController);
                }
                paid.run = run;
            })(paid = negotiations.paid || (negotiations.paid = {}));
        })(negotiations = app.negotiations || (app.negotiations = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.negotiations.paid.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var negotiations;
        (function (negotiations) {
            var detail;
            (function (detail_1) {
                detail_1.NAME = 'finadai.app.negotiations.detail';
                var NegotiationDetailController = /** @class */ (function () {
                    function NegotiationDetailController($state, negotiationsService, $mdDialog, $rootScope, notify, $stateParams, credits, negotiation) {
                        var _this = this;
                        this.$state = $state;
                        this.negotiationsService = negotiationsService;
                        this.$mdDialog = $mdDialog;
                        this.$rootScope = $rootScope;
                        this.notify = notify;
                        this.$stateParams = $stateParams;
                        this.paymentTypes = [];
                        this.processingRequest = false;
                        this.sendText = 'Validar negociación';
                        this.negotiation = null;
                        this.statusPayment = {
                            paid: {
                                label: 'Pagado',
                                class: 'success'
                            },
                            pending_payment: {
                                label: 'Pendiente',
                                class: 'warning'
                            },
                            expired: {
                                label: 'Expirado',
                                class: 'danger'
                            }
                        };
                        if ($state.is('app.negotiations.create')) {
                            this.credits = credits.data.data;
                            this.customer = this.credits[0].customer;
                            this.formData = {
                                activity_id: $stateParams.activityId,
                                credits: this.credits.map(function (x) {
                                    return { id: x.id };
                                }),
                                customer_id: this.customer.id,
                                payment_amount: null,
                                payment_type_id: null,
                                down_payment: null
                            };
                        }
                        else {
                            this.negotiation = negotiation.data.data;
                            this.credits = this.negotiation.credits;
                            this.customer = this.negotiation.customer;
                            this.generatePayments();
                        }
                        angular.forEach(this.credits, function (credit) {
                            if (credit.loan_type_id == 2) {
                                _this.negotiationsService.getCoAcredits(credit.loan_id, _this.customer.id).then(function (response) {
                                    credit.co_accredit_data = response.data.data;
                                });
                            }
                        });
                    }
                    NegotiationDetailController.prototype.loadPaymentTypes = function () {
                        var _this = this;
                        var pending_amount = this.credits.reduce(function (acum, item) { return acum + item.pending_amount; }, 0);
                        var proposal_amount = this.formData.payment_amount - this.formData.down_payment;
                        this.negotiationsService.getAvailablePaymentTypes({
                            pending_amount: pending_amount,
                            proposal_amount: proposal_amount
                        }).then(function (response) {
                            _this.formData.payment_type_id = null;
                            _this.paymentTypes = response.data;
                        });
                    };
                    NegotiationDetailController.prototype.cleanFields = function () {
                        this.formData.down_payment = 0;
                        this.loadPaymentTypes();
                    };
                    NegotiationDetailController.prototype.send = function (form, event) {
                        var _this = this;
                        if (form.$valid) {
                            this.processingRequest = true;
                            this.sendText = 'Enviando negociación...';
                            this.negotiationsService.save(this.formData).then(function (response) {
                                _this.$state.go('app.negotiations.detail', { negotiationId: response.data.id });
                                _this.dialogProposal(event, 1);
                                _this.$rootScope.$broadcast('updatePendingNegotiations');
                            }).catch(function (responseError) {
                                _this.sendText = 'Validar negociacion';
                                _this.processingRequest = false;
                            });
                        }
                    };
                    NegotiationDetailController.prototype.generatePayments = function () {
                        var _this = this;
                        if (this.negotiation.state == 'under_review')
                            return '';
                        this.negotiationsService.generatePayments({ negotiation_id: this.negotiation.id }).then(function (response) {
                            _this.negotiation.state = response.data.state;
                            if (response.data.payments) {
                                _this.negotiation.payments = response.data.payments;
                            }
                        }).catch(function (rejection) {
                            var output = '<span class="block mt10">Ocurrió un problema al generar el listado de pagos</span>';
                            if (rejection.status == 412 || rejection.status == 422 || rejection.status == 400) {
                                var errorsMessage = angular.isDefined(rejection.data.message) ? rejection.data.message : "Error";
                                if (typeof rejection.data.errors !== "string") {
                                    output += '<ol>';
                                    for (var field in rejection.data.errors) {
                                        for (var errorType in rejection.data.errors[field]) {
                                            var errorString = angular.isDefined(rejection.data.errors[field][errorType]["error"]) ? rejection.data.errors[field][errorType]["error"] : rejection.data.errors[field][errorType];
                                            output += '<li>' + errorString + '</li>';
                                        }
                                    }
                                    output += '</ol>';
                                }
                                else {
                                    output += '<ol><li>' + errorsMessage + '</li></ol>';
                                }
                                _this.notify(output, 'danger');
                            }
                        });
                    };
                    NegotiationDetailController.prototype.dialogProposal = function (ev, option) {
                        var text;
                        switch (option) {
                            case 1:
                                text = '<md-dialog aria-label="Términos y condiciones"><md-dialog-content class="md-dialog-content">' +
                                    '<p class="text-center"><img src="/assets/images/logo.png" width="100" /></p>' +
                                    '<h4 class="text-center">' +
                                    '<md-icon class="material-icons mt20 fs100 green">check_circle</md-icon></h4>' +
                                    '<h5 class="text-center">Negociación creada</h5>' +
                                    '</md-dialog-content>' +
                                    '<md-dialog-actions><md-button class="md-accent md-raised" ng-click="close()">Ok</md-button></md-dialog-actions>' +
                                    '</md-dialog>';
                                break;
                            case 2:
                                text = '<md-dialog aria-label="Términos y condiciones"><md-dialog-content class="md-dialog-content">' +
                                    '<p class="text-center"><img src="/assets/images/logo.png" width="100" /></p>' +
                                    '<h4 class="text-center">Lo sentimos<br />' +
                                    '<md-icon class="material-icons mt20 fs100 red">block</md-icon></h4>' +
                                    '<h5 class="text-center">Propuesta rechazada</h5>' +
                                    '</md-dialog-content>' +
                                    '<md-dialog-actions><md-button ng-click="close()">Ok</md-button></md-dialog-actions>' +
                                    '</md-dialog>';
                                break;
                        }
                        this.$mdDialog.show({
                            template: text,
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            controller: function ($scope, $mdDialog) {
                                $scope.close = function () {
                                    $mdDialog.hide();
                                };
                            },
                            fullscreen: false // Only for -xs, -sm breakpoints.
                        });
                    };
                    NegotiationDetailController.prototype.sendNegotiation = function (ev) {
                        var _this = this;
                        this.$mdDialog.show({
                            controller: SendNegotiationController,
                            templateUrl: 'app/customers/detail/formEmail.tpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            locals: {
                                config: {
                                    entity: { add: 'Enviar email', save: 'Enviar' },
                                    data: { negotiation_id: this.negotiation.id }
                                }
                            }
                        }).then(function (response) {
                            _this.notify('Negociación enviada');
                        });
                    };
                    NegotiationDetailController.prototype.authorize = function () {
                        var _this = this;
                        this.negotiationsService.authorize(this.negotiation.id).then(function (response) {
                            _this.notify('Negociación autorizada');
                            _this.negotiation.state = response.data.state;
                            _this.generatePayments();
                        });
                    };
                    return NegotiationDetailController;
                }());
                function SendNegotiationController(config, $mdDialog, $scope, negotiationsService) {
                    $scope.config = config;
                    $scope.formData = config.data;
                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                    $scope.submit = function (form) {
                        if (form.$valid) {
                            negotiationsService.send($scope.formData).then(function (response) {
                                $mdDialog.hide(response);
                            });
                        }
                    };
                }
                // la cantidad de pagos por el motno que quieren pagar debe ser >= el porcentaje minimo por el amount_payable
                function run() {
                    var detail = angular.module(detail_1.NAME, []);
                    detail.controller('NegotiationDetailController', NegotiationDetailController);
                }
                detail_1.run = run;
            })(detail = negotiations.detail || (negotiations.detail = {}));
        })(negotiations = app.negotiations || (app.negotiations = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.negotiations.detail.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var negotiations;
        (function (negotiations_1) {
            negotiations_1.NAME = 'finadai.app.negotiations';
            function ConfigRoutes($stateProvider, $urlRouterProvider) {
                $urlRouterProvider.when('/negotiations', '/negotiations/list');
                $stateProvider
                    .state('app.negotiations', {
                    templateUrl: 'app/negotiations/negotiations.tpl.html',
                    url: '/negotiations',
                })
                    .state('app.negotiations.paid', {
                    templateUrl: 'app/negotiations/paid/paid.tpl.html',
                    controller: 'NegotiationsPaidController',
                    url: '/paid',
                    resolve: {
                        agents: function (agentsService) {
                            return agentsService.get();
                        }
                    }
                })
                    .state('app.negotiations.list', {
                    templateUrl: 'app/negotiations/list/list.tpl.html',
                    controller: 'NegotiationsListController',
                    url: '/list',
                    resolve: {
                        agents: function (agentsService) {
                            return agentsService.get();
                        }
                    }
                })
                    .state('app.negotiations.create', {
                    templateUrl: 'app/negotiations/detail/detail.tpl.html',
                    // url: '/create/:creditId',
                    url: '/create/:customerId/:activityId',
                    controller: 'NegotiationDetailController',
                    controllerAs: 'vm',
                    resolve: {
                        // credit: (negotiationsService: services.NegotiationsService, $stateParams) => {
                        //   return negotiationsService.getCredit($stateParams.creditId);
                        // },
                        credits: function (negotiationsService, $stateParams) {
                            return negotiationsService.getCredits({ with: "customer,negotiation,loan_type", customer_id: $stateParams.customerId });
                        },
                        verifyCredit: function (credits, $q, $state, notify, $rootScope, whoIAm) {
                            var creditsWithCompleteNegotiation = credits.data.data.filter(function (x) { return angular.isDefined(x.negotiation) && x.negotiation.state == 'complete'; });
                            var creditsWithNotCompleteNegotiation = credits.data.data.filter(function (x) { return angular.isDefined(x.negotiation) && x.negotiation.state != 'complete'; });
                            if (creditsWithCompleteNegotiation.length > 0) {
                                notify("Al menos un crédito ya se encuentra en una negociación", 'danger');
                                $rootScope.$broadcast('preloader:hide');
                                if (whoIAm.privilege == 'customer') {
                                    $state.go('app.customers.profile');
                                }
                                else {
                                    $state.go('app.customers.detail', { customerCode: credits.data.data[0].customer_number });
                                }
                            }
                            if (creditsWithNotCompleteNegotiation.length > 0) {
                                $rootScope.$broadcast('preloader:hide');
                                $state.go('app.negotiations.detail', { negotiationId: credits.data.data[0].negotiation.id });
                            }
                            return true;
                        },
                        negotiation: function () { return null; }
                    }
                })
                    .state('app.negotiations.detail', {
                    templateUrl: 'app/negotiations/detail/detail.tpl.html',
                    url: '/detail/:negotiationId',
                    controller: 'NegotiationDetailController',
                    controllerAs: 'vm',
                    resolve: {
                        negotiation: function (negotiationsService, $stateParams) {
                            return negotiationsService.get($stateParams.negotiationId);
                        },
                        credits: function () { return null; }
                    }
                });
            }
            function run() {
                var negotiations = angular.module(negotiations_1.NAME, [
                    finadai.app.negotiations.detail.NAME,
                    finadai.app.negotiations.list.NAME,
                    finadai.app.negotiations.paid.NAME
                ]);
                negotiations.config(ConfigRoutes);
            }
            negotiations_1.run = run;
        })(negotiations = app.negotiations || (app.negotiations = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.negotiations.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var customers;
        (function (customers) {
            var timeline;
            (function (timeline_1) {
                timeline_1.NAME = 'finadai.app.customers.timeline';
                function CustomerTimelineController(customer, $scope) {
                    var _customer = customer.data.data;
                    _customer.all_logs = [];
                    $scope.filters = [
                        { name: "Direcciones", selected: true, type: "App\\Domain\\Identity\\Location" },
                        { name: "Teléfonos", selected: true, type: "App\\Domain\\Identity\\Phone" },
                        { name: "Emails", selected: true, type: "App\\Domain\\Identity\\Email" }
                    ];
                    angular.forEach(customer.data.data.locations, function (item) { _customer.all_logs = _customer.all_logs.concat(item.logs); });
                    angular.forEach(customer.data.data.phones, function (item) { _customer.all_logs = _customer.all_logs.concat(item.logs); });
                    angular.forEach(customer.data.data.emails, function (item) { _customer.all_logs = _customer.all_logs.concat(item.logs); });
                    $scope.customer = _customer;
                    $scope.displayFields = function (value) {
                        var output = '<ul>';
                        angular.forEach(value, function (value, key) { output += '<li>' + key + ": " + value + '</li>'; });
                        output += '</ul>';
                        return output;
                    };
                    $scope.filterLogs = function (logs) {
                        var selectedFilters = $scope.filters.filter(function (x) { return x.selected; }).map(function (x) { return x.type; });
                        return logs.filter(function (x) { return selectedFilters.indexOf(x.owner_type) >= 0; });
                    };
                }
                function run() {
                    var timeline = angular.module(timeline_1.NAME, []);
                    timeline.controller('CustomerTimelineController', CustomerTimelineController);
                }
                timeline_1.run = run;
            })(timeline = customers.timeline || (customers.timeline = {}));
        })(customers = app.customers || (app.customers = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.customers.timeline.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var customers;
        (function (customers) {
            var detail;
            (function (detail_1) {
                detail_1.NAME = "finadai.app.customers.detail";
                function CustomerDetailController(customer, creditInfo, negotiation, customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    $scope.hasNegotiation = false;
                    $scope.hasSelectedPlan = false;
                    $scope.granters = [];
                    $scope.customer = customer.data.Data;
                    $scope.user_pdf = whoIAm.pdf;
                    $scope.havePdf = whoIAm.pdf != "na";
                    $scope.the_bank = 0;
                    if ($scope.customer.NumCliente.startsWith("3")) {
                        $scope.the_bank = 3;
                    }
                    else if ($scope.customer.NumCliente.startsWith("4")) {
                        $scope.the_bank = 4;
                    }
                    else if ($scope.customer.NumCliente.startsWith("5")) {
                        $scope.the_bank = 5;
                    }
                    $scope.is_hsbc = $scope.customer.NumCliente.startsWith("3");
                    $scope.user_pdf_paid = whoIAm.pdf_paid;
                    $scope.havePdfPaid = whoIAm.pdf_paid != "na";
                    $scope.haveDueNegotiation = whoIAm.due_negotiation;
                    $scope.activityData = {};
                    $scope.selectedCredit = [];
                    $scope.selectedGranting = '';
                    $scope.customerCredits = angular.isArray(creditInfo.data.Data.Saldo) ? creditInfo.data.Data.Saldo : [creditInfo.data.Data.Saldo];
                    $scope.customerNegotiation = negotiation.data.Data;
                    $scope.hasNegotiation = angular.isDefined($scope.customerNegotiation.Encabezado);
                    $scope.negotitationDetailed = [];
                    if ($scope.hasNegotiation && angular.isDefined($scope.customerNegotiation.Detalle.ConvenioDetalle)) {
                        $scope.negotitationDetailed = angular.isArray($scope.customerNegotiation.Detalle.ConvenioDetalle) ? $scope.customerNegotiation.Detalle.ConvenioDetalle : [$scope.customerNegotiation.Detalle.ConvenioDetalle];
                    }
                    $scope.canCreateActivity = whoIAm.operations.indexOf('activities_store') >= 0;
                    $rootScope.$broadcast('searchOveraly:close');
                    $scope.loadingPaymentOptions = true;
                    $scope.paymentOptions = [];
                    $scope.hoy = new Date();
                    $scope.principioMes = moment().startOf('month').toDate();
                    $scope.terms = [
                        { text: "Reconozco la existencia de mi(s) crédito(s) que se identifica(n) arriba en la Sección \"Información Original del Credito\"", accepted: false },
                        { text: "Reconozco que a la Fecha Efectiva, mi saldo(s) es(son) el(los) que aparece arriba en la Sección \"Información Original del Credito\"", accepted: false },
                        { text: "Acepto que (i) mi saldo total sea redocumentado y que, una vez redocumentado, quede como se indica arriba en la Secci\u00F3n \"Condiciones de tu Nuevo Cr\u00E9dito\"\n, y (ii) los \n        dem\u00E1s t\u00E9rminos de mi(s) cr\u00E9dito(s) permanecen sin cambio", accepted: false },
                        { text: "Reconozco que, derivado de dicha redocumentación, adeudo el Nuevo Saldo que aparece arriba en la Sección \"Condiciones de tu Nuevo Crédito\"", accepted: false },
                        { text: "Acepto liquidar el Nuevo Saldo mediante el Pago y por el número de pagos que aparecen arriba en la Sección \"Condiciones de tu Nuevo Crédito\"", accepted: false },
                        { text: "Reconozco y acepto que, si incumplo cualquier pago del cr\u00E9dito redocumentado, mi(s) cr\u00E9dito(s) revertir\u00EDa(n) a los t\u00E9rminos que aparecen\n        en la Secci\u00F3n \"Informaci\u00F3n Original del Credito\" anterior y los pagos que haya yo realizado se abonar\u00EDan a dicho(s) cr\u00E9dito(s) de la Secci\u00F3n \"Informaci\u00F3n Original del Credito\", en los t\u00E9rminos del Contrato\n        de Cr\u00E9dito Original", accepted: false }
                    ];
                    customersService.proxyPaymentOptions({ pending_amount: finadai.models.proxy.getSaldoTotal(creditInfo.data.Data) }).then(function (response) {
                        $scope.loadingPaymentOptions = false;
                        $scope.paymentOptions = response.data.Data;
                        $scope.paymentOptions = [];
                    }).catch(function (error) {
                        $scope.loadingPaymentOptions = false;
                    });
                    /**
                     * TODO: can pay for Pagar en Banco depends on NumCliente validation.
                     * */
                    $scope.paymentPlans = [
                        {
                            title: "Pagar en Oxxo",
                            description: "Oxxo Pay es un servicio ofrecido por Femsa",
                            image: "/assets/images/oxxo-pay-logo-blanco.svg",
                            alt: "Oxxo Pay Logo",
                            canPay: function () { return true; },
                            is_oxxo_pay: 1
                        },
                        {
                            title: "Pagar en Banco",
                            description: "Es un Banco",
                            image: "/assets/images/logo-spei.png",
                            alt: "Banco Logo",
                            canPay: function () { return true; },
                            is_oxxo_pay: 0
                        }
                    ];
                    $scope.canSubmit = function () { return $scope.terms.filter(function (x) { return !x.accepted; }).length == 0; };
                    $scope.selectedPaymentType = null;
                    $scope.selectedPlan = null;
                    $scope.selectPaymentType = function (paymentType) {
                        setTimeout(function () {
                            jQuery('html, body').animate({ scrollTop: jQuery("#step2").offset().top - 70 }, 500);
                        }, 0);
                        paymentType.AmountNumber = parseFloat(paymentType.Amount);
                        $scope.selectedPaymentType = angular.copy(paymentType);
                    };
                    $scope.selectPlan = function (paymentPlan) {
                        setTimeout(function () {
                            jQuery('html, body').animate({ scrollTop: jQuery("#step3").offset().top - 90 }, 500);
                        }, 0);
                        $scope.selectedPlan = angular.copy(paymentPlan);
                        $scope.hasSelectedPlan = true;
                    };
                    $scope.refreshPage = function () {
                        location.reload();
                    };
                    $scope.cancelPlan = function (ev) {
                        // const confirm = $mdDialog.confirm()
                        //     .title('¿Qué quieres hacer?')
                        //     .textContent('')
                        //     .targetEvent(ev)
                        //     .ok('Cambiar las condiciones de mi nuevo credito (Cuanto, Como y/o Donde Pagar).')
                        //     .cancel('Pensarlo Mejor.');
                        //
                        // $mdDialog.show(confirm).then(function() {
                        //   location.reload();
                        // }, function() {
                        //     authService.logout().then(function (response) { $state.go('login'); });
                        // });
                        $mdDialog.show({
                            templateUrl: 'app/customers/detail/formQuestionNegotiation.tpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            controller: function ($scope) {
                                $scope.logout = function () {
                                    authService.logout().then(function (response) { $state.go('login'); }).then(function () { $mdDialog.hide(); }, function () { $mdDialog.hide(); });
                                };
                                $scope.refreshPage = function () {
                                    location.reload();
                                };
                            },
                            controllerAs: 'ctrl',
                            clickOutsideToClose: true,
                            escapeToClose: true,
                            fullscreen: false
                        });
                    };
                    $scope.refreshPage = function (ev) {
                        location.reload();
                    };
                    $scope.modificarInfoDialog = function (ev) {
                        var data = angular.copy($scope.customer);
                        data.FechaNacimiento = moment(data.FechaNacimiento).toDate();
                        $mdDialog.show({
                            controller: function ($scope, $mdDialog) {
                                $scope.formData = data;
                                $scope.submit = function (form) {
                                    if (form.$valid) {
                                        $scope.saving = true;
                                        delete $scope.formData.ReferenciaHSBC;
                                        $scope.formData.NumCliente;
                                        $scope.formData.rfc = $scope.formData.RFC;
                                        customersService.proxySaveCustomer($scope.formData).then(function (response) {
                                            $scope.saving = false;
                                            $mdDialog.hide(response.data.Data);
                                        }).catch(function (error) {
                                            $scope.saving = false;
                                            console.log(error);
                                            $mdDialog.hide();
                                        });
                                    }
                                };
                                $scope.cancel = function () {
                                    $mdDialog.hide();
                                };
                            },
                            templateUrl: 'app/customers/detail/formPersonalInfo.tpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            escapeToClose: true,
                            fullscreen: false
                        }).then(function (customer) {
                            if (customer != null) {
                                $scope.customer = customer;
                            }
                        }, function () {
                            $scope.status = 'You cancelled the dialog.';
                        });
                    };
                    $scope.generateNegotiation = function () {
                        // customersService.proxyGetNegotiation({rfc: whoIAm.rfc})
                        var promise = customersService.proxySaveNegotiation({
                            customer_number: whoIAm.customer_number,
                            rfc: whoIAm.rfc,
                            payment_type_id: $scope.selectedPaymentType.Id,
                            payment_amount: $scope.selectedPaymentType.Amount,
                            user_id: whoIAm.id,
                            phone: whoIAm.phone,
                            is_oxxo_pay: $scope.selectedPlan.is_oxxo_pay
                        });
                        $scope.loadingGeneratingNegotiation = true;
                        promise.then(function (response) {
                            $scope.generatedNegotiationResponse = response.data.Data.Encabezado;
                            $scope.pdf = response.data.Data.Encabezado.PDF;
                            $scope.loadingGeneratingNegotiation = false;
                        }).catch(function (error) {
                            $scope.loadingGeneratingNegotiation = false;
                        });
                    };
                    $scope.changeStatusCredit = function (credit) {
                        if (credit.credit_status_id != credit.new_credit_status_id) {
                            customersService.changeStatusCredit({ credit_id: credit.id, credit_status_id: credit.new_credit_status_id }).then(function (response) {
                                notify('Estado de Credito Actualizado.');
                            });
                        }
                    };
                    $scope.getFileIcon = function (file_path) {
                        if (file_path.endsWith('.png') || file_path.endsWith('.jpeg') || file_path.endsWith('.jpg') || file_path.endsWith('.gif'))
                            return 'fa-picture-o';
                        if (file_path.endsWith('.xls') || file_path.endsWith('.xlsx'))
                            return 'fa-file-excel-o';
                        if (file_path.endsWith('.doc') || file_path.endsWith('.docx'))
                            return 'fa-file-word-o';
                        if (file_path.endsWith('.pdf'))
                            return 'fa-file-pdf-o';
                        return 'fa-file-o';
                    };
                    $scope.getFileUrl = function (file_path) {
                        return proxifier(false) + file_path;
                    };
                    $scope.deleteFile = function (file, index) {
                        customersService.deleteFile(file.id, $scope.customer.id).then(function (response) {
                            if (response.status == 200) {
                                $scope.customer.media.splice(index, 1);
                            }
                        });
                    };
                    $scope.sendInviteForm = function (ev, negotiation) {
                        var formData = angular.isUndefined(negotiation) ? { customer_id: $scope.customer.id } : { negotiation_id: negotiation.id };
                        $mdDialog.show({
                            controller: function (config, $mdDialog, $scope, customersService) {
                                $scope.config = config;
                                $scope.formData = config.data;
                                $scope.cancel = function () { $mdDialog.cancel(); };
                                $scope.submit = function (form) {
                                    if (form.$valid) {
                                        var promise = angular.isUndefined($scope.formData.negotiation_id) ? customersService.sendInvite($scope.formData) : negotiationsService.send($scope.formData);
                                        promise.then(function (response) {
                                            $mdDialog.hide(response);
                                        });
                                    }
                                };
                            },
                            templateUrl: 'app/customers/detail/formEmail.tpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            locals: { config: { entity: { add: 'Enviar email', save: 'Enviar' }, data: formData } }
                        }).then(function (response) {
                            notify(negotiation == null ? 'Invitación enviada' : 'Negociación enviada');
                        });
                    };
                    $scope.getGranters = function () {
                        if ($scope.granters.length == 0) {
                            $scope.granters = [];
                            $scope.customer.credits.map(function (x) { return x.granter; }).forEach(function (el) {
                                if ($scope.granters.map(function (x) { return x.id; }).indexOf(el.id) < 0) {
                                    $scope.granters.push(el);
                                }
                            });
                        }
                        return $scope.granters;
                    };
                    $scope.form = function (entity, data, ev) {
                        $mdDialog.show({
                            controller: FormEntityController,
                            templateUrl: entity.formUrl,
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: { config: { entity: entity, data: data, customerId: $scope.customer.id } }
                        }).then(function (response) {
                            notify('Registro guardado');
                        });
                    };
                    $scope.formEditCredit = function (credit, index, ev) {
                        $mdDialog.show({
                            controller: FormCreditController,
                            templateUrl: 'app/customers/detail/formCredit.tpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: { config: { data: { credit_id: credit.id, pending_amount: credit.pending_amount, last_payment: credit.last_payment._date, amount_payable: credit.amount_payable } } }
                        }).then(function (response) {
                            notify('Crédito actualizado');
                            $scope.customer.credits[index] = response;
                        });
                    };
                    $scope.formCancelNegotiation = function (negotiation, index, ev) {
                        $mdDialog.show({
                            controller: FormNegotiationController,
                            templateUrl: 'app/customers/detail/formCancelNegotiation.tpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: { config: { data: { negotiation_id: negotiation.id } } }
                        }).then(function (response) {
                            notify('Negociación cancelada');
                        });
                    };
                    $scope.formEditCustomerName = function (customer, ev) {
                        $mdDialog.show({
                            controller: FormCustomerNameController,
                            templateUrl: 'app/customers/detail/formCustomerName.tpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: { config: { data: { customer_id: customer.id, name: customer.name, last_name: customer.last_name } } }
                        }).then(function (response) {
                            notify('Cliente actualizado');
                            $scope.customer.name = response.name;
                            $scope.customer.last_name = response.last_name;
                        });
                    };
                }
                function FormEntityController(config, $mdDialog, $scope, customersService) {
                    $scope.config = config;
                    $scope.formData = angular.copy($scope.config.data);
                    if (config.entity.type == "references" && angular.isDefined($scope.formData.relationship_id)) {
                        $scope.formData.relationship_id = $scope.formData.relationship_id.toString();
                    }
                    $scope.cancel = function () { $mdDialog.cancel(); };
                    $scope.submit = function (form) {
                        if (form.$valid) {
                            customersService.save($scope.formData, $scope.config.data.id, $scope.config.entity.type, $scope.config.customerId).then(function (response) {
                                $mdDialog.hide(response);
                            });
                        }
                    };
                }
                function FormCreditController(config, $mdDialog, $scope, negotiationsService) {
                    $scope.formData = config.data;
                    $scope.cancel = function () { $mdDialog.cancel(); };
                    $scope.submit = function (form) {
                        if (form.$valid) {
                            negotiationsService.saveCredit(config.data.credit_id, $scope.formData).then(function (response) {
                                $mdDialog.hide(response.data);
                            });
                        }
                    };
                }
                function FormNegotiationController(config, $mdDialog, $scope, negotiationsService) {
                    $scope.formData = config.data;
                    $scope.cancel = function () { $mdDialog.cancel(); };
                    $scope.submit = function (form) {
                        if (form.$valid) {
                            negotiationsService.cancelNegotiation($scope.formData).then(function (response) {
                                $mdDialog.hide(response.data);
                            });
                        }
                    };
                }
                function FormCustomerNameController(config, $mdDialog, $scope, customersService) {
                    $scope.formData = config.data;
                    $scope.cancel = function () { $mdDialog.cancel(); };
                    $scope.submit = function (form) {
                        if (form.$valid) {
                            customersService.updateName(config.data.customer_id, $scope.formData).then(function (response) {
                                $mdDialog.hide(response.data);
                            });
                        }
                    };
                }
                function run() {
                    var detail = angular.module(detail_1.NAME, []);
                    detail.controller("CustomerDetailController", CustomerDetailController);
                }
                detail_1.run = run;
            })(detail = customers.detail || (customers.detail = {}));
        })(customers = app.customers || (app.customers = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.customers.detail.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var customers;
        (function (customers_1) {
            customers_1.NAME = "finadai.app.customers";
            function ConfigRoutes($stateProvider) {
                $stateProvider.state('app.customers', {
                    templateUrl: 'app/customers/customers.tpl.html',
                    url: '/customers',
                })
                    .state('app.customers.detail', {
                    templateUrl: 'app/customers/detail/detail.tpl.html',
                    url: '/detail/:customerCode',
                    controller: 'CustomerDetailController',
                    resolve: {
                        customer: function (customersService, $stateParams) {
                            return customersService.get($stateParams.customerCode);
                        }
                    }
                })
                    .state('app.customers.profile', {
                    templateUrl: 'app/customers/detail/detail.tpl.html',
                    url: '/profile',
                    controller: 'CustomerDetailController',
                    resolve: {
                        customer: function (customersService, whoIAm) { return customersService.proxyGetCustomer({ customer_number: whoIAm.customer_number }); },
                        negotiation: function (customersService, whoIAm) { return customersService.proxyGetNegotiation({ customer_number: whoIAm.customer_number }); },
                        creditInfo: function (customersService, whoIAm) { return customersService.proxySearchCredit({ customer_number: whoIAm.customer_number }); }
                    }
                })
                    .state('app.customers.cancel_negotiation', {
                    templateUrl: 'app/customers/cancel_negotiation.tpl.html',
                    url: '/cancel_negotiation',
                    controller: 'CustomerCancelNegotiationController',
                    resolve: {
                        customer: function (customersService, whoIAm) { return customersService.proxyGetCustomer({ customer_number: whoIAm.customer_number }); },
                        negotiation: function (customersService, whoIAm) { return customersService.proxyGetNegotiation({ customer_number: whoIAm.customer_number }); },
                        creditInfo: function (customersService, whoIAm) { return customersService.proxySearchCredit({ customer_number: whoIAm.customer_number }); }
                    }
                })
                    .state('app.customers.timeline', {
                    templateUrl: 'app/customers/timeline/timeline.tpl.html',
                    url: '/timeline/:customerNumber',
                    controller: 'CustomerTimelineController',
                    resolve: {
                        customer: function (customersService, $stateParams) {
                            if ($stateParams.customerNumber) {
                                return customersService.get($stateParams.customerNumber, true);
                            }
                            // return customersService.getInfo();
                        }
                    }
                });
            }
            function run() {
                var customers = angular.module(customers_1.NAME, [
                    finadai.app.customers.detail.NAME,
                    finadai.app.customers.timeline.NAME
                ]);
                customers.config(ConfigRoutes);
            }
            customers_1.run = run;
        })(customers = app.customers || (app.customers = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.customers.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var customers;
        (function (customers) {
            var cancel_negotiation;
            (function (cancel_negotiation_1) {
                cancel_negotiation_1.NAME = "finadai.app.customers.cancel_negotiation";
                function CustomerCancelNegotiationController(customer, creditInfo, negotiation, customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    return;
                    $scope.customer = customer.data.Data;
                    $scope.credit = creditInfo.data.Data;
                    $scope.negotiation = negotiation.data.Data;
                    $scope.user = whoIAm;
                    $scope.selectedReason = { id: null, name: '' };
                    $scope.reasons = [
                        { id: 1, name: 'El plazo es insuficiente/El monto es muy alto' },
                        { id: 2, name: 'Desconfío de la información que me proporcionaron para realizar el (los) pago(s)' },
                        { id: 3, name: 'Registraron este convenio sin mi completa aprobación' }
                    ];
                    $scope.hoy = new Date();
                    $scope.refreshPage = function () {
                        location.reload();
                    };
                    $scope.submitNegotiationCancel = function () {
                        $scope.cancelNegotiation = true;
                        var promise = customersService.proxyCancelNegotiation({
                            customer_number: whoIAm.customer_number,
                            rfc: whoIAm.rfc,
                            reason_id: $scope.selectedReason.id,
                            user_id: whoIAm.id,
                        });
                        promise.then(function (response) {
                            $scope.canceldNegotiationResponse = response.data.Data.Encabezado;
                            $scope.cancelNegotiation = false;
                            notify('Negociación Cancelada.');
                            $state.go('app.customers.profile');
                        }).catch(function (error) {
                            $scope.cancelNegotiation = false;
                            if (error.status != 422) {
                                notify('Tuvimos un problema, contáctanos via chat.', 'danger');
                            }
                        });
                    };
                }
                function run() {
                    var cancel_negotiation = angular.module(cancel_negotiation_1.NAME, []);
                    cancel_negotiation.controller("CustomerCancelNegotiationController", CustomerCancelNegotiationController);
                }
                cancel_negotiation_1.run = run;
            })(cancel_negotiation = customers.cancel_negotiation || (customers.cancel_negotiation = {}));
        })(customers = app.customers || (app.customers = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.customers.cancel_negotiation.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var admin;
        (function (admin) {
            var create;
            (function (create_1) {
                create_1.NAME = "finadai.app.admin.create";
                function AdminCreateController(customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    $scope.formData = {};
                    $scope.negotiationData = {};
                    $scope.searchComplete = false;
                    $scope.searchingInProgress = false;
                    $scope.sendingNegotiation = false;
                    $scope.oxxoReferenceUpdate = "";
                    $scope.displayOxxoOption = false;
                    $scope.negotiationData.want_oxxo = 1;
                    $scope.plazos = [
                        { id: 3, name: 'Semana' },
                        { id: 4, name: 'Catorcena' },
                        { id: 1, name: 'Mes' },
                        { id: 5, name: 'Dia' }
                    ];
                    $scope.quieresOxxos = [
                        { id: 1, name: 'Si' },
                        { id: 0, name: 'No' }
                    ];
                    $scope.formasDePagos = [
                        { id: 1, name: 'Oxxo' },
                        { id: 0, name: 'Banco' }
                    ];
                    var msgCustomer = "";
                    $scope.canCreateNegotiationForCustomer = whoIAm.operations.indexOf('admin_create_negotiation') >= 0;
                    $scope.changeWantOxxo = function () {
                        if ($scope.negotiationData.payment_type.id == 0) {
                            $scope.displayOxxoOption = true;
                        }
                        else {
                            $scope.displayOxxoOption = false;
                        }
                    };
                    $scope.submitNegotiation = function (form) {
                        if (form.$valid) {
                            $scope.oxxoReferenceUpdate = "";
                            $scope.sendingNegotiation = true;
                            customersService.proxySaveManualNegotiation({
                                customer_number: $scope.negotiationData.customer_number,
                                payment_amount: $scope.negotiationData.payment_amount,
                                term: $scope.negotiationData.term.id,
                                payment_type: $scope.negotiationData.payment_type.id,
                                want_oxxo: $scope.negotiationData.want_oxxo.id,
                                num_payments: $scope.negotiationData.num_payments,
                                observation_code: $scope.negotiationData.observation_code,
                                phone: $scope.negotiationData.cellphone,
                                email: $scope.negotiationData.email,
                                source: $scope.negotiationData.source,
                                user_id: whoIAm.id
                            }).then(function (response) {
                                console.log(response);
                                notify('Negociación Creada');
                                $scope.sendingNegotiation = false;
                                this.negotiationForm.reset();
                                $scope.negotiationData.customer_number = "";
                                $scope.negotiationData.payment_amount = "";
                                $scope.negotiationData.num_payments = "";
                                $scope.negotiationData.observation_code = "";
                                $scope.negotiationData.cellphone = "";
                                $scope.negotiationData.email = "";
                                $scope.negotiationData.source = "";
                                if (response.data.Data.Encabezado.ReferenciaOxxo > 0) {
                                    $scope.oxxoReferenceUpdate = "Nueva Referencia OXXOPay Solicitada: " + response.data.Data.Encabezado.ReferenciaOxxo;
                                }
                            }, function (response) {
                                console.log(response);
                                notify('Fallo Crear Negociación', 'danger');
                                $scope.sendingNegotiation = false;
                            });
                        }
                    };
                }
                function run() {
                    var create = angular.module(create_1.NAME, []);
                    create.controller("AdminCreateController", AdminCreateController);
                }
                create_1.run = run;
            })(create = admin.create || (admin.create = {}));
        })(admin = app.admin || (app.admin = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.admin.create.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var admin;
        (function (admin) {
            var search;
            (function (search_1) {
                search_1.NAME = "finadai.app.admin.search";
                function AdminSearchController(customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    $scope.formData = {};
                    $scope.negotiationData = {};
                    $scope.searchComplete = false;
                    $scope.searchingInProgress = false;
                    $scope.sendingNegotiation = false;
                    $scope.messageCustomer = "";
                    $scope.plazos = [
                        { id: 3, name: 'Semana' },
                        { id: 4, name: 'Catorcena' },
                        { id: 1, name: 'Mes' }
                    ];
                    var msgCustomer = "";
                    $scope.canSearchForCustomer = whoIAm.operations.indexOf('admin_search_customer') >= 0;
                    $scope.searchCustomerData = function (form) {
                        if (form.$valid) {
                            $scope.searchComplete = false;
                            $scope.searchingInProgress = true;
                            customersService.proxyGetCustomer({ customer_number: $scope.formData.customer_number })
                                .then(function (response) {
                                $scope.search_customer = response.data;
                                if ($scope.search_customer.Data.PrimerNombre !== undefined) {
                                    msgCustomer = "RFC: " + $scope.search_customer.Data.RFC + " <br /> Nombre Completo: " + $scope.search_customer.Data.PrimerNombre + " " + $scope.search_customer.Data.SegundoNombre + " " + $scope.search_customer.Data.ApellidoPaterno + " " + $scope.search_customer.Data.ApellidoMaterno;
                                    msgCustomer += "<hr />";
                                }
                                else {
                                    msgCustomer = "No se encontro acreditado";
                                }
                            }, function () {
                                $scope.searchingInProgress = false;
                            }).then(function () {
                                customersService.proxySearchCredit({ customer_number: $scope.formData.customer_number }).then(function (response) {
                                    var $credit_info = "";
                                    $scope.search_creditInfo = response.data;
                                    $scope.search_creditInfo = angular.isArray($scope.search_creditInfo.Data.Saldo) ? $scope.search_creditInfo.Data.Saldo : [$scope.search_creditInfo.Data.Saldo];
                                    angular.forEach($scope.search_creditInfo, function (value, key) {
                                        $credit_info += $scope.displayFields(value);
                                    });
                                    msgCustomer += $credit_info;
                                    $scope.messageCustomer = msgCustomer;
                                    $scope.searchComplete = true;
                                    $scope.searchingInProgress = false;
                                }, function () {
                                    $scope.searchComplete = true;
                                });
                            });
                        }
                    };
                    $scope.displayFields = function (value) {
                        var output = '<ul>';
                        angular.forEach(value, function (value, key) {
                            output += '<li>' + key + ": " + value + '</li>';
                        });
                        output += '</ul>';
                        output += '<hr />';
                        return output;
                    };
                }
                function run() {
                    var search = angular.module(search_1.NAME, []);
                    search.controller("AdminSearchController", AdminSearchController);
                }
                search_1.run = run;
            })(search = admin.search || (admin.search = {}));
        })(admin = app.admin || (app.admin = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.admin.search.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var admin;
        (function (admin) {
            var find_negotiation;
            (function (find_negotiation) {
                find_negotiation.NAME = "finadai.app.admin.find_negotiation";
                function AdminFindNegotiationController(customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    $scope.formData = {};
                    $scope.findNegotiationComplete = false;
                    $scope.findNegotiationInProgress = false;
                    $scope.sendingNegotiation = false;
                    $scope.messageCustomer = "";
                    var msgCustomer = "";
                    $scope.canfindNegotiation = whoIAm.operations.indexOf('admin_find_negotiation') >= 0;
                    $scope.searchFindNegotiationData = function (form) {
                        if (form.$valid) {
                            $scope.findNegotiationComplete = false;
                            $scope.findNegotiationInProgress = true;
                            var $negotiation_info_1 = "";
                            customersService.proxySearchNegotiation({ customer_number: $scope.formData.customer_number })
                                .then(function (response) {
                                angular.forEach(response.data, function (value, key) {
                                    $negotiation_info_1 += $scope.displayFields(value);
                                });
                                $negotiation_info_1 += "<ul><li>Detalle</li></ul>";
                                angular.forEach(response.data.Data.Detalle, function (value, key) {
                                    $negotiation_info_1 += $scope.displayFields(value);
                                });
                                $scope.messageCustomer = $negotiation_info_1;
                                $scope.findNegotiationInProgress = false;
                                $scope.findNegotiationComplete = true;
                            }, function () {
                                $scope.findNegotiationInProgress = false;
                            });
                        }
                    };
                    $scope.displayFields = function (value) {
                        var output = '<ul>';
                        angular.forEach(value, function (value, key) {
                            var normalizedKey = key != null ? key.toString() : '';
                            if (normalizedKey !== "Detalle" && typeof value === "object") {
                                output += $scope.displayFields(value);
                            }
                            else if (normalizedKey !== "Detalle") {
                                output += '<li>' + normalizedKey + ": " + value + '</li>';
                            }
                        });
                        output += '</ul>';
                        output += '<hr />';
                        return output;
                    };
                }
                ;
                function run() {
                    var search = angular.module(find_negotiation.NAME, []);
                    search.controller("AdminFindNegotiationController", AdminFindNegotiationController);
                }
                find_negotiation.run = run;
            })(find_negotiation = admin.find_negotiation || (admin.find_negotiation = {}));
        })(admin = app.admin || (app.admin = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.admin.find_negotiation.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var admin;
        (function (admin) {
            var cancel_negotiation;
            (function (cancel_negotiation) {
                cancel_negotiation.NAME = "finadai.app.admin.cancel_negotiation";
                function AdminCancelNegotiationController(customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    $scope.formData = {};
                    $scope.cancelNegotiationData = {};
                    $scope.cancelingNegotiation = false;
                    $scope.messageCustomer = "";
                    $scope.canCancelNegotiationForCustomer = whoIAm.operations.indexOf('admin_cancel_negotiation') >= 0;
                    $scope.cancelNegotiation = function (form) {
                        if (form.$valid) {
                            $scope.cancelingNegotiation = true;
                            customersService.proxyGetCustomer({ customer_number: $scope.cancelNegotiationData.customer_number })
                                .then(function (response) {
                                $scope.search_customer = response.data;
                                console.log(response.data);
                            }, function () {
                                $scope.cancelingNegotiation = false;
                            })
                                .then(function () {
                                customersService.proxyCancelNegotiation({
                                    customer_number: $scope.cancelNegotiationData.customer_number,
                                    reason_id: 3,
                                    user_id: whoIAm.id,
                                    is_admin: true
                                })
                                    .then(function (response) {
                                    notify('Convenio Cancelado');
                                    $scope.cancelingNegotiation = false;
                                    this.cancelNegotiationForm.reset();
                                }, function (response) {
                                    notify('Fallo Cancelar Convenio', 'danger');
                                    $scope.cancelingNegotiation = false;
                                });
                            }, function () {
                                $scope.cancelingNegotiation = false;
                            });
                        }
                    };
                }
                function run() {
                    var cancel = angular.module(cancel_negotiation.NAME, []);
                    cancel.controller("AdminCancelNegotiationController", AdminCancelNegotiationController);
                }
                cancel_negotiation.run = run;
            })(cancel_negotiation = admin.cancel_negotiation || (admin.cancel_negotiation = {}));
        })(admin = app.admin || (app.admin = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.admin.cancel_negotiation.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var admin;
        (function (admin) {
            var update;
            (function (update) {
                update.NAME = "finadai.app.admin.update";
                function AdminUpdateCustomerController(customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    $scope.formData = {};
                    $scope.searchData = {};
                    $scope.updatingCustomer = false;
                    $scope.searchingCustomer = false;
                    $scope.showUpdateForm = false;
                    $scope.canUpdateCustomer = whoIAm.operations.indexOf('admin_update_customer') >= 0;
                    $scope.searchCustomer = function (form) {
                        $scope.showUpdateForm = false;
                        if (form.$valid) {
                            $scope.searchingCustomer = true;
                            customersService.proxyGetCustomer({ customer_number: $scope.searchData.customer_number })
                                .then(function (response) {
                                $scope.formData = response.data;
                                $scope.formData = $scope.formData.Data;
                                $scope.formData.FechaNacimiento = moment($scope.formData.FechaNacimiento).toDate();
                                console.log(response.data);
                                $scope.searchingCustomer = false;
                                $scope.showUpdateForm = true;
                            }, function () {
                                notify('No se Encontro Acreditado', 'danger');
                                $scope.showUpdateForm = false;
                                $scope.searchingCustomer = false;
                            })
                                .catch(function (error) {
                                notify('No se Encontro Acreditado', 'danger');
                                $scope.showUpdateForm = false;
                                $scope.searchingCustomer = false;
                                console.log(error);
                            });
                        }
                    };
                    $scope.ValidarTelefono = function () {
                        $scope.updatingCustomer = true;
                        if ($scope.formData.TelefonoMovil != "") {
                            customersService.proxyValidateCellphone($scope.formData)
                                .then(function (response) {
                                var codigo = response.data.Data.Codigo;
                                notify('SMS Enviado Validar Codigo: ' + codigo, 'success', 25000);
                                $scope.updatingCustomer = false;
                            }, function () {
                                notify('Error en el Servicio', 'danger');
                                $scope.updatingCustomer = false;
                            })
                                .catch(function (error) {
                                $scope.updatingCustomer = false;
                                console.log(error);
                            });
                            $scope.updatingCustomer = false;
                        }
                    };
                    $scope.updateCustomer = function (form) {
                        if (form.$valid) {
                            $scope.updatingCustomer = true;
                            delete $scope.formData.ReferenciaHSBC;
                            $scope.formData.NumCliente;
                            $scope.formData.rfc = $scope.formData.RFC;
                            customersService.proxyUpdateCustomerAdmin($scope.formData)
                                .then(function (response) {
                                notify('Acreditado Actualizado');
                                $scope.updatingCustomer = false;
                                this.updateCustomerForm.reset();
                                $scope.showUpdateForm = false;
                            }, function () {
                                notify('Fallo Actualizar Acreditado', 'danger');
                                $scope.updatingCustomer = false;
                            })
                                .catch(function (error) {
                                $scope.updatingCustomer = false;
                                console.log(error);
                            });
                        }
                    };
                }
                function run() {
                    var cancel = angular.module(update.NAME, []);
                    cancel.controller("AdminUpdateCustomerController", AdminUpdateCustomerController);
                }
                update.run = run;
            })(update = admin.update || (admin.update = {}));
        })(admin = app.admin || (app.admin = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.admin.update.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var admin;
        (function (admin) {
            var create_reference;
            (function (create_reference) {
                create_reference.NAME = "finadai.app.admin.create_reference";
                function AdminCreateReferenceController(customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    $scope.formData = {};
                    $scope.createReferenceData = {};
                    $scope.creatingReference = false;
                    $scope.referencesCreated = false;
                    $scope.newReferences = "";
                    $scope.canCreateReference = whoIAm.operations.indexOf('admin_create_single_reference') >= 0;
                    $scope.createReferenceOxxo = function (form) {
                        $scope.referencesCreated = false;
                        if (form.$valid) {
                            $scope.creatingReference = true;
                            customersService.proxyCreateReferenceAdmin({
                                customer_number: $scope.createReferenceData.customer_number,
                                amount: $scope.createReferenceData.amount
                            })
                                .then(function (response) {
                                console.log(response.data);
                                $scope.references = response.data;
                                var $data_reference = "<ul>";
                                angular.forEach($scope.references.Data, function (value, key) {
                                    $data_reference += "<li>" + value["Reference"] + " - $" + value["Amount"] + "</li>";
                                });
                                $data_reference += '</ul>';
                                $data_reference += '<hr />';
                                $scope.newReferences = $data_reference;
                                $scope.creatingReference = false;
                                $scope.referencesCreated = true;
                            }, function () {
                                $scope.creatingReference = false;
                            });
                        }
                    };
                }
                function run() {
                    var find = angular.module(create_reference.NAME, []);
                    find.controller("AdminCreateReferenceController", AdminCreateReferenceController);
                }
                create_reference.run = run;
            })(create_reference = admin.create_reference || (admin.create_reference = {}));
        })(admin = app.admin || (app.admin = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.admin.create_reference.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var admin;
        (function (admin) {
            var change_sic;
            (function (change_sic) {
                change_sic.NAME = "finadai.app.admin.change_sic";
                function AdminChangeSICController(customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    $scope.formData = {};
                    $scope.canChangeSIC = whoIAm.operations.indexOf('admin_change_sic_customer') >= 0;
                    $scope.searchingCreditsCustomer = false;
                    $scope.showCreditCustomersForm = false;
                    $scope.changingSICCredits = false;
                    $scope.searchCreditCustomerData = {};
                    $scope.creditsCustomers = {};
                    $scope.creditsCustomersData = {};
                    $scope.creditsCustomersData.credits_sic = [];
                    $scope.changeMotive = function (credit) {
                    };
                    $scope.reviewIfChecked = function (credit) {
                        return credit.EstatusSIC == 1;
                    };
                    $scope.toogleChange = function (credit) {
                        if (credit.EstatusSIC == 1) {
                            credit.EstatusSIC = 0;
                        }
                        else {
                            credit.EstatusSIC = 1;
                        }
                    };
                    $scope.searchCustomersCredits = function (form) {
                        $scope.showCreditCustomersForm = false;
                        $scope.searchingCreditsCustomer = true;
                        if (form.$valid) {
                            customersService.proxySearchCredit({
                                customer_number: $scope.searchCreditCustomerData.customer_number
                            })
                                .then(function (response) {
                                console.log(response.data);
                                $scope.creditsCustomers = response.data;
                                $scope.creditsCustomers = angular.isArray($scope.creditsCustomers.Data.Saldo) ? $scope.creditsCustomers.Data.Saldo : [$scope.creditsCustomers.Data.Saldo];
                                $scope.searchingCreditsCustomer = false;
                                $scope.showCreditCustomersForm = true;
                            }, function () {
                                $scope.searchingCreditsCustomer = false;
                            });
                        }
                        else {
                            $scope.searchingCreditsCustomer = false;
                        }
                    };
                    $scope.changeSICCredits = function (form) {
                        $scope.changingSICCredits = true;
                        $scope.searchingCreditsCustomer = true;
                        customersService.proxyChangeSICCustomerAdmin({
                            credits: $scope.creditsCustomers
                        })
                            .then(function (response) {
                            notify('Datos Actualizados con Exito');
                            $scope.searchingCreditsCustomer = false;
                            $scope.showCreditCustomersForm = false;
                            $scope.searchCreditCustomerData.customer_number = 0;
                        });
                        $scope.changingSICCredits = false;
                    };
                }
                function run() {
                    var find = angular.module(change_sic.NAME, []);
                    find.controller("AdminChangeSICController", AdminChangeSICController);
                }
                change_sic.run = run;
            })(change_sic = admin.change_sic || (admin.change_sic = {}));
        })(admin = app.admin || (app.admin = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.admin.change_sic.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var admin;
        (function (admin) {
            var find;
            (function (find_1) {
                find_1.NAME = "finadai.app.admin.find";
                function AdminFindController(customersService, whoIAm, $rootScope, $scope, notify, confirm, $mdDialog, $state, negotiationsService, proxifier, $q, authService) {
                    $scope.formData = {};
                    $scope.searchingInProgress = false;
                    $scope.searchComplete = false;
                    $scope.messageCustomer = "";
                    $scope.customer_number = 0;
                    var msgCustomer = "";
                    $scope.canFindCustomer = whoIAm.operations.indexOf('admin_find_customer') >= 0;
                    $scope.otorgantes = [];
                    customersService.proxyGetOriginator().then(function (response) {
                        var otorgantes = response.data.Data.Originadores;
                        otorgantes.forEach(function (o) {
                            $scope.otorgantes.push({ id: o.Originador, name: o.OriginadorNombre });
                        });
                    });
                    $scope.findCustomerData = function (form) {
                        $scope.customer_number = null;
                        if (form.$valid) {
                            $scope.searchComplete = false;
                            $scope.searchingInProgress = true;
                            $scope.formData.originator_id = $scope.formData.originator.id;
                            customersService.proxySearch($scope.formData).then(function (response) {
                                if (angular.isArray(response.data.Data.Saldo)) {
                                    var saldos = response.data.Data.Saldo;
                                    saldos.forEach(function (s) {
                                        $scope.customer_number = s.NumCliente;
                                    });
                                }
                                else {
                                    var saldo = response.data.Data.Saldo;
                                    $scope.customer_number = saldo.NumCliente;
                                }
                            }, function (response) {
                                console.log(response);
                                notify('No se encontraron datos en la busqueda', 'danger');
                                $scope.searchingInProgress = false;
                            }).then(function () {
                                if ($scope.customer_number !== null) {
                                    customersService.proxyGetCustomer({ customer_number: $scope.customer_number }).then(function (response) {
                                        $scope.searchingInProgress = false;
                                        notify('Acreditado encontrado');
                                        $scope.search_customer = response.data;
                                        if ($scope.search_customer.Data.PrimerNombre !== undefined) {
                                            msgCustomer = "Número de Cliente: " + $scope.customer_number + " <br />RFC: " + $scope.search_customer.Data.RFC + " <br />Nombre Completo: " + $scope.search_customer.Data.PrimerNombre + " " + $scope.search_customer.Data.ApellidoPaterno + " " + $scope.search_customer.Data.ApellidoMaterno;
                                            msgCustomer += "<hr />";
                                        }
                                        else {
                                            msgCustomer = "No se encontro acreditado";
                                        }
                                        $scope.messageCustomer = msgCustomer;
                                        $scope.searchComplete = true;
                                        this.findCreditForm.reset();
                                    }, function (response) {
                                        console.log(response);
                                        notify('Fallo la busqueda', 'danger');
                                        $scope.searchingInProgress = false;
                                    });
                                }
                            }, function (response) {
                                console.log(response);
                                notify('Fallo la busqueda', 'danger');
                                $scope.searchingInProgress = false;
                            });
                            /*customersService.proxyGetCustomer({customer_number: $scope.formData.customer_number})
                                .then(function (response) {
                                    $scope.search_customer = response.data;
                                    if ($scope.search_customer.Data.PrimerNombre !== undefined) {
                                        msgCustomer = "Nombre Completo: " + $scope.search_customer.Data.PrimerNombre + " " + $scope.search_customer.Data.ApellidoPaterno + " " + $scope.search_customer.Data.ApellidoMaterno;
                                        msgCustomer += "<hr />";
                                    } else {
                                        msgCustomer = "No se encontro acreditado";
                                    }
                                }, function () {
            
                                    notify('Fallo la busqueda', 'danger');
                                    $scope.searchingInProgress = false;
                                }).then(function () {
                                customersService.proxySearchCredit({customer_number: $scope.formData.customer_number}).then(function (response) {
                                    let $credit_info = "";
                                    $scope.search_creditInfo = response.data;
                                    $scope.search_creditInfo = angular.isArray($scope.search_creditInfo.Data.Saldo) ? $scope.search_creditInfo.Data.Saldo : [$scope.search_creditInfo.Data.Saldo];
                                    angular.forEach($scope.search_creditInfo, function (value, key) {
                                        $credit_info += $scope.displayFields(value);
                                    });
                                    msgCustomer += $credit_info;
                                    $scope.messageCustomer = msgCustomer;
                                    $scope.searchComplete = true;
                                    $scope.searchingInProgress = false;
                                }, function () {
                                    $scope.searchComplete = true;
                                });
                            })*/
                        }
                    };
                    $scope.displayFields = function (value) {
                        var output = '<ul>';
                        angular.forEach(value, function (value, key) {
                            output += '<li>' + key + ": " + value + '</li>';
                        });
                        output += '</ul>';
                        output += '<hr />';
                        return output;
                    };
                }
                function run() {
                    var find = angular.module(find_1.NAME, []);
                    find.controller("AdminFindController", AdminFindController);
                }
                find_1.run = run;
            })(find = admin.find || (admin.find = {}));
        })(admin = app.admin || (app.admin = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.admin.find.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var admin;
        (function (admin_1) {
            admin_1.NAME = "finadai.app.admin";
            function ConfigRoutes($stateProvider) {
                $stateProvider.state('app.admin', {
                    templateUrl: 'app/admin/admin.tpl.html',
                    url: '/admin',
                })
                    .state('app.admin.create', {
                    templateUrl: 'app/admin/create/create.tpl.html',
                    url: '/createNegotiation/',
                    controller: 'AdminCreateController',
                    resolve: {}
                })
                    .state('app.admin.search', {
                    templateUrl: 'app/admin/search/search.tpl.html',
                    url: '/searchCustomer',
                    controller: 'AdminSearchController',
                    resolve: {}
                })
                    .state('app.admin.find_negotiation', {
                    templateUrl: 'app/admin/findNegotiation/findNegotiation.tpl.html',
                    url: '/findNegotiation',
                    controller: 'AdminFindNegotiationController',
                    resolve: {}
                })
                    .state('app.admin.cancel_negotiation', {
                    templateUrl: 'app/admin/cancel/cancel.tpl.html',
                    url: '/cancelNegotiation',
                    controller: 'AdminCancelNegotiationController',
                    resolve: {}
                })
                    .state('app.admin.find', {
                    templateUrl: 'app/admin/find/find.tpl.html',
                    url: '/findCustomer',
                    controller: 'AdminFindController',
                    resolve: {}
                })
                    .state('app.admin.update', {
                    templateUrl: 'app/admin/update/update.tpl.html',
                    url: '/updateCustomer',
                    controller: 'AdminUpdateCustomerController',
                    resolve: {}
                }).state('app.admin.create_reference', {
                    templateUrl: 'app/admin/create_reference/create_reference.tpl.html',
                    url: '/createReference',
                    controller: 'AdminCreateReferenceController',
                    resolve: {}
                }).state('app.admin.change_sic', {
                    templateUrl: 'app/admin/change_sic/change_sic.tpl.html',
                    url: '/changeSIC',
                    controller: 'AdminChangeSICController',
                    resolve: {}
                });
            }
            function run() {
                var admin = angular.module(admin_1.NAME, [
                    finadai.app.admin.search.NAME,
                    finadai.app.admin.create.NAME,
                    finadai.app.admin.cancel_negotiation.NAME,
                    finadai.app.admin.update.NAME,
                    finadai.app.admin.find.NAME,
                    finadai.app.admin.create_reference.NAME,
                    finadai.app.admin.find_negotiation.NAME,
                    finadai.app.admin.change_sic.NAME
                ]);
                admin.config(ConfigRoutes);
            }
            admin_1.run = run;
        })(admin = app.admin || (app.admin = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.admin.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var search;
        (function (search_1) {
            search_1.NAME = "finadai.app.search";
            function SearchController($scope, $state) {
                $scope.search = function () {
                    $state.go('app.search.results', { q: $scope.query });
                };
            }
            function run() {
                var search = angular.module(search_1.NAME, []);
                search.controller("SearchController", SearchController);
            }
            search_1.run = run;
        })(search = app.search || (app.search = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.search.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var upload;
        (function (upload_1) {
            upload_1.NAME = 'finadai.app.upload';
            function ConfigRoutes($stateProvider) {
                $stateProvider.state('app.upload', {
                    url: '/upload',
                    templateUrl: 'app/upload/upload.tpl.html',
                    controller: 'UploadController'
                });
            }
            function UploadController($scope, $element, FileUploader, proxifier, $localStorage, notify) {
                $scope.fileData = { operation: 'create', type: 'full' };
                $scope.uploader = new FileUploader({
                    url: [proxifier(), 'finadai', 'customers', 'file'].join('/'),
                    formData: { 'key': 'value' }
                });
                $scope.selectFile = function () {
                    jQuery('input#fileChoose').trigger('click');
                };
                $scope.uploader.onBeforeUploadItem = function (item) {
                    item.formData = jQuery.makeArray($scope.fileData);
                    item.headers = { Authorization: $localStorage.apiToken };
                };
                $scope.uploader.onSuccessItem = function (item, response, status, headers) {
                    $scope.fileData = {};
                    $scope.uploadForm.$setPristine();
                    $scope.uploadForm.$setUntouched();
                    notify('El archivo ha sido agregado y será procesado en un momento.');
                    $scope.uploader.clearQueue();
                };
                $scope.submit = function () {
                    if ($scope.uploader.queue.length > 0) {
                        $scope.uploader.uploadAll();
                    }
                };
            }
            function run() {
                var upload = angular.module(upload_1.NAME, []);
                upload.config(ConfigRoutes);
                upload.controller('UploadController', UploadController);
            }
            upload_1.run = run;
        })(upload = app.upload || (app.upload = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.upload.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var forgotPassword;
        (function (forgotPassword_1) {
            forgotPassword_1.NAME = 'finadai.app.forgotPassword';
            function ForgotPasswordController($scope, $stateParams, authService) {
                $scope.formData = { email: $stateParams.email };
                $scope.errorMessages = [];
                $scope.successMessage = '';
                $scope.submit = function (form) {
                    if (form.$valid) {
                        authService.sendInstructions($scope.formData).then(function (response) {
                            $scope.successMessage = response.data.message;
                        }, function (responseError) {
                            if (responseError.status == 404) {
                                $scope.errorMessages = responseError.data.errors['Not Found'];
                            }
                        });
                    }
                };
            }
            function run() {
                var forgotPassword = angular.module(forgotPassword_1.NAME, []);
                forgotPassword.controller('ForgotPasswordController', ForgotPasswordController);
            }
            forgotPassword_1.run = run;
        })(forgotPassword = app.forgotPassword || (app.forgotPassword = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.forgotPassword.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var changePassword;
        (function (changePassword_1) {
            changePassword_1.NAME = 'finadai.app.changePassword';
            function ConfigRoutes($stateProvider) {
                $stateProvider.state('changePassword', {
                    templateUrl: "app/changePassword/changePassword.tpl.html",
                    url: "/updatePassword",
                    controller: "ChangePasswordController",
                    params: { token: '', email: '' }
                })
                    .state('forgotPassword', {
                    templateUrl: "app/changePassword/forgotPassword.tpl.html",
                    url: "/forgotPassword",
                    controller: "ForgotPasswordController",
                    params: { email: '' }
                })
                    .state('resetPassword', {
                    templateUrl: "app/changePassword/changePassword.tpl.html",
                    url: "/resetPassword/:token",
                    controller: "ChangePasswordController"
                });
            }
            function ChangePasswordController($scope, $stateParams, $state, authService, $localStorage, notify) {
                $scope.loggedIn = $stateParams.loggedIn;
                $scope.formData = { token: $stateParams.token };
                $scope.isUpdatePassword = $state.is('changePassword');
                if ($state.is('changePassword') && $stateParams.token == '') {
                    $state.go('login');
                }
                $scope.submit = function (form) {
                    if (form.$valid) {
                        if ($state.is('changePassword')) {
                            authService.changeDefaultPassword($scope.formData).then(function (response) {
                                authService.login({ email: $stateParams.email, password: $scope.formData.password }).then(function (response) {
                                    $localStorage.apiToken = "Bearer " + response.data.token;
                                    $state.go('app.dashboard');
                                });
                            });
                        }
                        else if ($state.is('resetPassword')) {
                            authService.resetPassword($scope.formData).then(function (response) {
                                notify('Contraseña actualizada');
                                $state.go('login');
                            }, function (responseError) {
                                if (angular.isDefined(responseError.data.errors))
                                    $scope.errorMessages = responseError.data.errors['Bad Request'];
                            });
                        }
                        else {
                            authService.changePassword($scope.formData).then(function (response) {
                                notify('Contraseña actualizada');
                            });
                        }
                    }
                };
            }
            function run() {
                var changePassword = angular.module(changePassword_1.NAME, []);
                changePassword.config(ConfigRoutes);
                changePassword.controller('ChangePasswordController', ChangePasswordController);
            }
            changePassword_1.run = run;
        })(changePassword = app.changePassword || (app.changePassword = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.changePassword.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var register;
        (function (register_1) {
            register_1.NAME = 'finadai.app.register';
            function RegisterController($scope, customersService, notify, $stateParams, appConfig, $mdDialog, $state) {
                $scope.registerData = { customer_code: $stateParams.customerCode };
                var fields = $scope.fields = [
                    { label: 'Nombre', name: 'name', inputType: 'text', icon: 'perm_identity', help: 'Sin abreviaciones' },
                    { label: 'Apellido Paterno', name: 'last_name', inputType: 'text', icon: '', help: 'Sin abreviaciones' },
                    { label: 'RFC', name: 'rfc', inputType: 'text', icon: 'verified_user' },
                    { label: 'Email', name: 'email', inputType: 'email', icon: 'mail_outline' },
                    { label: 'Celular', name: 'phone', inputType: 'text', icon: 'local_phone', help: 'Incluir lada, sin símbolos, 10 dígitos.' },
                    { label: 'Password', name: 'password', inputType: 'password', icon: 'lock_outline', help: 'Minimo 6 Caracteres.' },
                    { label: '', name: 'customer_number', inputType: 'hidden', icon: '' },
                ];
                $scope.registerData['name'] = $stateParams.name;
                $scope.registerData['last_name'] = $stateParams.last_name;
                $scope.registerData['rfc'] = $stateParams.rfc;
                $scope.registerData['customer_number'] = $stateParams.customer_number;
                $scope.sended = false;
                $scope.loading = false;
                $scope.submit = function (form) {
                    $scope.success = false;
                    if (form.$valid) {
                        $scope.loading = true;
                        customersService.proxyRegister($scope.registerData).then(function (response) {
                            $scope.loading = false;
                            $scope.sended = true;
                            if (angular.isDefined(response.data.error)) {
                                $scope.message = { type: 'warning', text: 'No se encontró registro de cliente, favor de comunicarse vía chat.' };
                            }
                            else {
                                $state.go('registerSuccess');
                            }
                        }, function (responseError) {
                            $scope.loading = false;
                            $scope.sended = true;
                            $scope.message = { type: 'danger', text: 'Ocurrió un error al tratar de enviar su información, favor de comunicarse vía chat.' };
                        });
                    }
                };
                $scope.showTerms = function (ev) {
                    $mdDialog.show({
                        templateUrl: 'app/layout/terms.tpl.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: false // Only for -xs, -sm breakpoints.
                    });
                };
            }
            function run() {
                var register = angular.module(register_1.NAME, []);
                register.controller('RegisterController', RegisterController);
            }
            register_1.run = run;
        })(register = app.register || (app.register = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.register.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var findYourCredit;
        (function (findYourCredit_1) {
            findYourCredit_1.NAME = 'finadai.app.findYourCredit';
            function FindYourCreditController($scope, customersService, $mdDialog, $filter) {
                return;
                $scope.formData = {};
                $scope.message = null;
                $scope.customer_number = 0;
                $scope.userData = null;
                $scope.loading = false;
                $scope.otorgantes = [];
                customersService.proxyGetOriginator().then(function (response) {
                    var otorgantes = response.data.Data.Originadores;
                    otorgantes.forEach(function (o) {
                        $scope.otorgantes.push({ id: o.Originador, name: o.OriginadorNombre });
                    });
                });
                $scope.submit = function (form) {
                    if (form.$valid) {
                        $scope.loading = true;
                        $scope.formData.originator_id = $scope.formData.originator.id;
                        customersService.proxySearch($scope.formData).then(function (response) {
                            $scope.loading = false;
                            if (angular.isArray(response.data.Data.Saldo)) {
                                var saldos = response.data.Data.Saldo;
                                var message_1 = "<h4 class=\"search_saldo\">Saldo total: ".concat($filter('currency')(parseFloat(saldos[0].SaldoTotal)), "</h4><br /><br />");
                                saldos.forEach(function (s) {
                                    message_1 += "<p> Tipo de producto: ".concat(s.TipoProducto, " <br/>\n                          Numero Tarjeta de Credito/Credito: ").concat(s.CreditoId, " <br />\n                          Originador: ").concat(s.OriginadorNombre, " <br />\n                          Fecha de apertura: ").concat($filter('momentDate')(s.FechaApertura), " <br />\n                          *Monto Dispuesto: ").concat($filter('currency')(parseFloat(s.MontoSolicitado)), "<br /><br />\n                          Saldo Total: ").concat($filter('currency')(parseFloat(s.SaldoTotal)), " <br /><br />\n                          <br /><br /><br />\n                          *Saldo de Castigo a la Fecha de Adquisici\u00F3n</p>");
                                    $scope.customer_number = s.NumCliente;
                                });
                                $scope.message = {
                                    type: 'success',
                                    text: message_1,
                                    title: "Amigo, el detalle de tus cr\u00E9ditos es:",
                                    stub: 'Para conocer los detalles de tus créditos y realizar un acuerdo para liquidar tu deuda, es necesario crear una cuenta'
                                };
                            }
                            else {
                                var saldo = response.data.Data.Saldo;
                                $scope.message = {
                                    type: 'success',
                                    text: " <p>Tipo de producto: ".concat(saldo.TipoProducto, " <br/>\n                       Numero Tarjeta de Credito/Credito: ").concat(saldo.CreditoId, " <br />\n                       Originador: ").concat(saldo.OriginadorNombre, " <br />\n                       Fecha de apertura: ").concat($filter('momentDate')(saldo.FechaApertura), " <br />\n                      *Monto Dispuesto: ").concat($filter('currency')(parseFloat(saldo.MontoSolicitado)), " <br />\n                       Saldo Total: ").concat($filter('currency')(parseFloat(saldo.SaldoTotal)), " <br />\n                       <br /><br /><br />\n                       *Saldo de Castigo a la Fecha de Adquisici\u00F3n</p>"),
                                    title: "Amigo, el detalle de tu cr\u00E9dito es:",
                                    stub: 'Para conocer el detalle de tu crédito y realizar un acuerdo para liquidar tu deuda, es necesario crear una cuenta'
                                };
                                $scope.customer_number = saldo.NumCliente;
                            }
                        }).catch(function (rejection) {
                            $scope.loading = false;
                            if (rejection.data.data && rejection.data.data.DetailedException) {
                                $scope.message = { type: 'danger', text: rejection.data.data.DetailedException };
                            }
                            else {
                                $scope.message = {
                                    type: 'danger',
                                    title: "No hemos encontrado detalle de algún crédito con la información que has proporcionado. Comunícate a través del chat para que podamos asesorarte."
                                };
                            }
                        });
                    }
                };
                $scope.showTerms = function (ev) {
                    $mdDialog.show({
                        templateUrl: 'app/layout/terms.tpl.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: false // Only for -xs, -sm breakpoints.
                    });
                };
            }
            function run() {
                var findYourCredit = angular.module(findYourCredit_1.NAME, []);
                findYourCredit.controller('FindYourCreditController', FindYourCreditController);
            }
            findYourCredit_1.run = run;
        })(findYourCredit = app.findYourCredit || (app.findYourCredit = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.findYourCredit.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var payYourCredit;
        (function (payYourCredit_1) {
            payYourCredit_1.NAME = 'finadai.app.payYourCredit';
            function PayYourCreditController($scope, customersService, $mdDialog, $filter) {
                $scope.formData = {};
                $scope.message = null;
                $scope.customer_number = 0;
                $scope.userData = null;
                $scope.loading = false;
                $scope.submit = function (form) {
                    if (form.$valid) {
                        $scope.loading = true;
                        customersService.proxyNewSearch($scope.formData).then(function (response) {
                            $scope.loading = false;
                            var customer = response.data.Data.Customer;
                            var payment_text = "<p><strong>La informaci\u00F3n para realizar tu pago es: <br />\nNumero de Cuenta HSBC*: 4051630465<br />\nServicio: 487<br />\nReferencia: ".concat(customer.ReferenciaHSBC, "<br />\n</strong></p>\n<p>*Beneficiario <a target=\"_blank\" href=\"http://www.quam.mx/preguntas.php#tertius\">TERTIUS</a></p>");
                            if (angular.isArray(response.data.Data.Saldo)) {
                                var saldos = response.data.Data.Saldo;
                                var message_1 = "";
                                saldos.forEach(function (s) {
                                    message_1 += "<p> Tipo de producto: ".concat(s.TipoProducto, " <br/>\n                          Numero Tarjeta de Credito/Credito: ").concat(s.CreditoId, " <br />\n                         <br /></p>");
                                    $scope.customer_number = s.NumCliente;
                                });
                                $scope.message = {
                                    type: 'success',
                                    text: message_1,
                                    title: 'Amigo, el detalle de tus créditos es:',
                                    stub: payment_text
                                };
                            }
                            else {
                                var saldo = response.data.Data.Saldo;
                                $scope.message = {
                                    type: 'success',
                                    text: " <p>Tipo de producto: ".concat(saldo.TipoProducto, " <br/>\n                       Numero Tarjeta de Credito/Credito: ").concat(saldo.CreditoId, " <br />\n                      </p>"),
                                    title: 'Amigo, el detalle de tu crédito es:',
                                    stub: payment_text
                                };
                                $scope.customer_number = saldo.NumCliente;
                            }
                        }).catch(function (rejection) {
                            $scope.loading = false;
                            if (rejection.data.data && rejection.data.data.DetailedException) {
                                $scope.message = { type: 'danger', text: rejection.data.data.DetailedException };
                            }
                            else {
                                $scope.message = { type: 'danger', title: "No hemos encontrado detalle de algún crédito con la información que has proporcionado. Comunícate a través del chat para que podamos asesorarte." };
                            }
                        });
                    }
                };
                $scope.showTerms = function (ev) {
                    $mdDialog.show({
                        templateUrl: 'app/layout/terms.tpl.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: false // Only for -xs, -sm breakpoints.
                    });
                };
            }
            function run() {
                var payYourCredit = angular.module(payYourCredit_1.NAME, []);
                payYourCredit.controller('PayYourCreditController', PayYourCreditController);
            }
            payYourCredit_1.run = run;
        })(payYourCredit = app.payYourCredit || (app.payYourCredit = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.payYourCredit.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var login;
        (function (login_1) {
            login_1.NAME = 'finadai.app.login';
            function LoginController($scope, $state, $rootScope, authService, $location, $localStorage, tokenAccess, tokenConfirm, $q, customersService, $mdDialog) {
                $scope.message = null;
                $scope.tokenMessage = null;
                if (tokenAccess != null) {
                    if (tokenAccess.status == 200) {
                        cancelNegotiation(tokenAccess.data.Token);
                    }
                    else {
                        $scope.tokenMessage = { type: 'danger', text: tokenAccess.data.error };
                    }
                }
                if (tokenConfirm != null) {
                    if (tokenConfirm.status == 200) {
                        loginRedirect(tokenConfirm.data.Token);
                    }
                    else {
                        $scope.tokenMessage = { type: 'danger', text: tokenConfirm.data.error };
                    }
                }
                $scope.loginData = { email: '', password: '' };
                var original = angular.copy($scope.loginData);
                $scope.canSubmit = function () {
                    return true;
                    // return $scope.material_login_form.$valid && !angular.equals($scope.user, original);
                };
                $scope.showTerms = function (ev) {
                    $mdDialog.show({
                        templateUrl: 'app/layout/terms.tpl.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: false // Only for -xs, -sm breakpoints.
                    });
                };
                $scope.login = function () {
                    $scope.processingRequest = true;
                    $rootScope.$broadcast('preloader:active');
                    authService.login($scope.loginData).then(function (response) {
                        if (angular.isDefined(response.data.error)) {
                            $state.go('changePassword', {
                                token: response.data.token,
                                email: $scope.loginData.email
                            });
                        }
                        else {
                            loginRedirect(response.data.token);
                        }
                    }, function (responseLoginError) {
                        if (responseLoginError.status == 401) {
                            $scope.message = { type: 'danger', text: responseLoginError.data.error };
                        }
                        $scope.processingRequest = false;
                    });
                };
                function loginRedirect(token) {
                    var queryParams = $location.search();
                    $localStorage.apiToken = "Bearer " + token;
                    if (angular.isDefined(queryParams.send_to) && angular.isDefined(queryParams.gi) && angular.isDefined(queryParams.cn)) {
                        $state.go('app.negotiations.create', { granterId: queryParams.gi, customerId: queryParams.cn });
                    }
                    else {
                        authService.isLoggedIn().then(function (response) {
                            if (response.privilege == "customer") {
                                $state.go('app.customers.profile');
                            }
                            else if (response.privilege == "operational") {
                                $state.go('app.admin.search');
                            }
                            else {
                                $state.go('app.admin.create');
                            }
                            $scope.processingRequest = false;
                        });
                    }
                }
                function cancelNegotiation(token) {
                    $localStorage.apiToken = "Bearer " + token;
                    authService.isLoggedIn().then(function (response) {
                        $state.go('app.customers.cancel_negotiation');
                        $scope.processingRequest = false;
                    });
                }
            }
            function run() {
                var login = angular.module(login_1.NAME, []);
                login.controller("LoginController", LoginController);
            }
            login_1.run = run;
        })(login = app.login || (app.login = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.login.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var granters;
        (function (granters) {
            var create;
            (function (create_1) {
                create_1.NAME = 'finadai.app.granters.create';
                function grantersCreateController($scope, grantersService, notify, $state, data) {
                    $scope.agentData = data;
                    $scope.isCreate = $state.is('app.granters.create');
                    $scope.submit = function (form) {
                        if (form.$valid) {
                            grantersService.save($scope.agentData).then(function (response) {
                                notify('Registro guardado');
                                $state.go('app.granters.list');
                            });
                        }
                    };
                }
                function run() {
                    var create = angular.module(create_1.NAME, []);
                    create.controller('grantersCreateController', grantersCreateController);
                }
                create_1.run = run;
            })(create = granters.create || (granters.create = {}));
        })(granters = app.granters || (app.granters = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.granters.create.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var granters;
        (function (granters) {
            var list;
            (function (list_1) {
                list_1.NAME = "finadai.app.granters.list";
                function grantersListController($scope, $q, grantersService, notify, $http, $state) {
                    $scope.selected = [];
                    $scope.limitOptions = [5, 10, 15];
                    $scope.options = {
                        rowSelection: true,
                        multiSelect: true,
                        autoSelect: true,
                        decapitate: false,
                        largeEditDialog: false,
                        boundaryLinks: false,
                        limitSelect: true,
                        pageSelect: true
                    };
                    $scope.query = {
                        order: '-updated_at._date',
                        limit: 10,
                        page: 1
                    };
                    $scope.toggleLimitOptions = function () {
                        $scope.limitOptions = $scope.limitOptions ? undefined : [5, 10, 15];
                    };
                    $scope.reload = function () {
                        $scope.promise = grantersService.get().then(function (response) {
                            $scope.granters = response.data;
                            return response;
                        });
                    };
                    $scope.reload();
                    $scope.remove = function (id) {
                        $q.all($scope.selected.map(function (item) { return grantersService.remove(item.id); })).then(function (responses) {
                            $scope.selected = [];
                            notify('Registro(s) eliminado(s)');
                            $scope.reload();
                        });
                    };
                    $scope.edit = function (e) {
                        $state.go('app.granters.detail', { agentId: $scope.selected[0].id });
                    };
                }
                function run() {
                    var list = angular.module(list_1.NAME, []);
                    list.controller('grantersListController', grantersListController);
                }
                list_1.run = run;
            })(list = granters.list || (granters.list = {}));
        })(granters = app.granters || (app.granters = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.granters.list.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var granters;
        (function (granters_1) {
            granters_1.NAME = "finadai.app.granters";
            function ConfigRoutes($stateProvider, $urlRouterProvider) {
                $urlRouterProvider.when('/granters', '/granters/list');
                $stateProvider.state('app.granters', {
                    templateUrl: 'app/granters/granters.tpl.html',
                    url: '/granters'
                })
                    .state('app.granters.list', {
                    templateUrl: 'app/granters/list/list.tpl.html',
                    controller: 'grantersListController',
                    url: '/list'
                })
                    .state('app.granters.create', {
                    templateUrl: 'app/granters/create/create.tpl.html',
                    controller: 'grantersCreateController',
                    url: '/create',
                    resolve: { data: function () { return {}; } }
                })
                    .state('app.granters.detail', {
                    templateUrl: 'app/granters/create/create.tpl.html',
                    controller: 'grantersCreateController',
                    url: '/detail/:agentId',
                    resolve: {
                        data: function (grantersService, $stateParams) {
                            return grantersService.get($stateParams.agentId).then(function (response) {
                                return { id: response.data.data.id, name: response.data.data.name, deposit_data: response.data.data.deposit_data };
                            });
                        }
                    }
                });
            }
            function run() {
                var granters = angular.module(granters_1.NAME, [
                    finadai.app.granters.list.NAME,
                    finadai.app.granters.create.NAME
                ]);
                granters.config(ConfigRoutes);
            }
            granters_1.run = run;
        })(granters = app.granters || (app.granters = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.granters.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var agents;
        (function (agents) {
            var create;
            (function (create_1) {
                create_1.NAME = 'finadai.app.agents.create';
                function AgentsCreateController($scope, agentsService, notify, $state, data) {
                    $scope.agentData = data;
                    $scope.isCreate = $state.is('app.agents.create');
                    $scope.submit = function (form) {
                        if (form.$valid) {
                            agentsService.save($scope.agentData).then(function (response) {
                                notify('Registro guardado');
                                $state.go('app.agents.list');
                            });
                        }
                    };
                }
                function run() {
                    var create = angular.module(create_1.NAME, []);
                    create.controller('AgentsCreateController', AgentsCreateController);
                }
                create_1.run = run;
            })(create = agents.create || (agents.create = {}));
        })(agents = app.agents || (app.agents = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.agents.create.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var agents;
        (function (agents) {
            var list;
            (function (list_1) {
                list_1.NAME = "finadai.app.agents.list";
                function AgentsListController($scope, $q, agentsService, notify, $http, $state) {
                    $scope.selected = [];
                    $scope.limitOptions = [5, 10, 15];
                    $scope.options = {
                        rowSelection: true,
                        multiSelect: true,
                        autoSelect: true,
                        decapitate: false,
                        largeEditDialog: false,
                        boundaryLinks: false,
                        limitSelect: true,
                        pageSelect: true
                    };
                    $scope.query = {
                        order: '-updated_at._date',
                        limit: 10,
                        page: 1
                    };
                    $scope.toggleLimitOptions = function () {
                        $scope.limitOptions = $scope.limitOptions ? undefined : [5, 10, 15];
                    };
                    $scope.reload = function () {
                        $scope.promise = agentsService.get().then(function (response) {
                            $scope.agents = response.data;
                            return response;
                        });
                    };
                    $scope.reload();
                    $scope.remove = function (id) {
                        $q.all($scope.selected.map(function (item) { return agentsService.remove(item.id); })).then(function (responses) {
                            $scope.selected = [];
                            notify('Registro(s) eliminado(s)');
                            $scope.reload();
                        });
                    };
                    $scope.edit = function (e) {
                        $state.go('app.agents.detail', { agentId: $scope.selected[0].id });
                    };
                }
                function run() {
                    var list = angular.module(list_1.NAME, []);
                    list.controller('AgentsListController', AgentsListController);
                }
                list_1.run = run;
            })(list = agents.list || (agents.list = {}));
        })(agents = app.agents || (app.agents = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.agents.list.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var agents;
        (function (agents_1) {
            agents_1.NAME = "finadai.app.agents";
            function ConfigRoutes($stateProvider, $urlRouterProvider) {
                $urlRouterProvider.when('/agents', '/agents/list');
                $stateProvider.state('app.agents', {
                    templateUrl: 'app/agents/agents.tpl.html',
                    url: '/agents'
                })
                    .state('app.agents.list', {
                    templateUrl: 'app/agents/list/list.tpl.html',
                    controller: 'AgentsListController',
                    url: '/list'
                })
                    .state('app.agents.create', {
                    templateUrl: 'app/agents/create/create.tpl.html',
                    controller: 'AgentsCreateController',
                    url: '/create',
                    resolve: { data: function () { return {}; } }
                })
                    .state('app.agents.detail', {
                    templateUrl: 'app/agents/create/create.tpl.html',
                    controller: 'AgentsCreateController',
                    url: '/detail/:agentId',
                    resolve: {
                        data: function (agentsService, $stateParams) {
                            return agentsService.get($stateParams.agentId).then(function (response) {
                                return { id: response.data.data.id, name: response.data.data.name, email: response.data.data.user.email, user_id: response.data.data.user.id };
                            });
                        }
                    }
                });
            }
            function run() {
                var agents = angular.module(agents_1.NAME, [
                    finadai.app.agents.list.NAME,
                    finadai.app.agents.create.NAME
                ]);
                agents.config(ConfigRoutes);
            }
            agents_1.run = run;
        })(agents = app.agents || (app.agents = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.agents.run();

var finadai;
(function (finadai) {
    var app;
    (function (app) {
        var dashboard;
        (function (dashboard_1) {
            dashboard_1.NAME = 'finadai.app.dashboard';
            function DashboardController($scope, whoIAm, $mdDialog) {
                var actions = $scope.actions = [
                    {
                        name: 'Crear Negociación',
                        is_search: false,
                        state: 'app.admin.create',
                        icon: 'add_circle',
                        permission: 'admin_create_negotiation'
                    },
                    {
                        name: 'Cancelar Negociación',
                        is_search: false,
                        state: 'app.admin.cancel_negotiation',
                        icon: 'block',
                        permission: 'admin_cancel_negotiation'
                    },
                    {
                        name: 'Actualizar Datos Cliente',
                        is_search: false,
                        state: 'app.admin.update',
                        icon: 'autorenew',
                        permission: 'admin_update_customer'
                    },
                    {
                        name: 'Buscar Cliente por ID',
                        is_search: false,
                        state: 'app.admin.search',
                        icon: 'search',
                        permission: 'admin_search_customer'
                    },
                    {
                        name: 'Buscar Negociación por ID',
                        is_search: false,
                        state: 'app.admin.find_negotiation',
                        icon: 'search',
                        permission: 'admin_find_negotiation'
                    },
                    {
                        name: 'Buscar Cliente por Datos',
                        is_search: false,
                        state: 'app.admin.find',
                        icon: 'people',
                        permission: 'admin_find_customer'
                    },
                    {
                        name: 'Crear Referencia Unica',
                        is_search: false,
                        state: 'app.admin.create_reference',
                        icon: 'receipt',
                        permission: 'admin_create_single_reference'
                    },
                    {
                        name: 'Archivo SIC',
                        is_search: false,
                        state: 'app.admin.change_sic',
                        icon: 'dns',
                        permission: 'admin_change_sic_customer'
                    },
                    {
                        name: 'Mi perfil',
                        is_search: false,
                        state: 'app.customers.profile',
                        icon: 'person',
                        permission: 'customers_get_info'
                    }
                ];
                if (whoIAm.privilege == 'customer') {
                    $mdDialog.show({
                        template: '<md-dialog><md-dialog-content class="md-dialog-content">' +
                            '<h2 class="text-center">¡Aquí <i>tú</i> tienes el control!</h2>' +
                            '<p class="text-center">Sigue los siguientes pasos:' +
                            '<ol>' +
                            '<li>Da click a mi perfil...</li>' +
                            '<li>Revisa y actualiza tu información personal</li>' +
                            '<li>Revisa la información de tu(s) crédito(s)</li>' +
                            '<li>Haz tu propuesta y recibe respuesta inmediata</li>' +
                            '<li>Acepta términos y condiciones</li>' +
                            '</ol></p>' +
                            '</md-dialog-content>' +
                            '<md-dialog-actions><md-button ng-click="close()">Ok</md-button></md-dialog-actions>' +
                            '</md-dialog>',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        controller: function ($scope, $mdDialog) {
                            $scope.close = function () {
                                $mdDialog.hide();
                            };
                        },
                        fullscreen: false // Only for -xs, -sm breakpoints.
                    });
                }
            }
            function run() {
                var dashboard = angular.module(dashboard_1.NAME, []);
                dashboard.controller('DashboardController', DashboardController);
            }
            dashboard_1.run = run;
        })(dashboard = app.dashboard || (app.dashboard = {}));
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.dashboard.run();

var finadai;
(function (finadai) {
    var lang;
    (function (lang_1) {
        lang_1.NAME = 'finadai.lang';
        function i18nConfig($translateProvider) {
            $translateProvider.useStaticFilesLoader({
                prefix: 'assets/i18n/',
                suffix: '.json'
            });
            $translateProvider.preferredLanguage('es');
            $translateProvider.useSanitizeValueStrategy(null);
        }
        function LangCtrl($scope, $translate) {
            $scope.lang = 'Español';
            this.openMenu = function ($mdOpenMenu, ev) {
                var originatorEv = ev;
                $mdOpenMenu(ev);
            };
            $scope.langs = [
                'Español',
                'English',
                '中文',
                '日本語'
            ];
            $scope.setLang = function (index) {
                var lang = this.langs[index];
                switch (lang) {
                    case 'English':
                        $translate.use('en');
                        break;
                    case 'Español':
                        $translate.use('es');
                        break;
                    case '中文':
                        $translate.use('zh');
                        break;
                    case '日本語':
                        $translate.use('ja');
                        break;
                }
                return $scope.lang = lang;
            };
            $scope.getFlag = function () {
                var lang;
                lang = $scope.lang;
                switch (lang) {
                    case 'English': return 'flags-american';
                    case 'Español': return 'flags-spain';
                    case '中文': return 'flags-china';
                    case '日本語': return 'flags-japan';
                }
            };
        }
        function run() {
            var lang = angular.module(lang_1.NAME, ['pascalprecht.translate']);
            lang.config(i18nConfig);
            lang.controller('LangCtrl', LangCtrl);
        }
        lang_1.run = run;
    })(lang = finadai.lang || (finadai.lang = {}));
})(finadai || (finadai = {}));
finadai.lang.run();

var finadai;
(function (finadai) {
    var config;
    (function (config_1) {
        config_1.NAME = "finadai.config";
        function ConfigRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            // if(window.location.host != 'finadaiapp.app')
            //$locationProvider.html5Mode(false);
            // For unmatched routes
            $urlRouterProvider.otherwise('/');
            // Application routes
            $stateProvider
                .state('app', {
                abstract: true,
                controller: 'AppController',
                templateUrl: 'app/app.tpl.html',
                resolve: {
                    whoIAm: function (authService) {
                        return authService.isLoggedIn();
                    }
                }
            })
                .state('app.dashboard', {
                url: '/',
                templateUrl: 'app/dashboard/dashboard.tpl.html',
                controller: 'DashboardController'
            })
                .state('app.map', {
                url: '/map',
                template: '<iframe src="http://map.quam.mx" width="100%" height="700"></iframe>'
            })
                .state('app.notFound', {
                // url: '/notFound',
                templateUrl: 'app/layout/404.tpl.html',
                onEnter: function ($rootScope) {
                    $rootScope.$broadcast('searchOveraly:close');
                }
            })
                .state('app.changePassword', {
                templateUrl: "app/changePassword/changePasswordLoggedIn.tpl.html",
                url: "/changePassword",
                controller: "ChangePasswordController"
            })
                .state('register', {
                templateUrl: "app/register/register.tpl.php",
                url: "/registro",
                controller: "RegisterController",
                params: {
                    name: null,
                    rfc: null,
                    last_name: null,
                    customer_number: null,
                    hiddenParam: 'YES',
                }
            })
                .state('registerSuccess', {
                templateUrl: "app/register/registerSuccess.tpl.php",
                url: "/registroExito",
            })
                .state('findYourCredit', {
                templateUrl: "app/findYourCredit/findYourCredit.tpl.html",
                url: "/findYourCredit",
                controller: "FindYourCreditController",
                resolve: {}
            })
                .state('login', {
                templateUrl: "app/login/login.tpl.html",
                url: "/login/:token?send_to&cn&gi",
                controller: "LoginController",
                resolve: {
                    tokenAccess: function () { return null; },
                    tokenConfirm: function (customersService, $stateParams) {
                        if (angular.isDefined($stateParams.token) && $stateParams.token != '') {
                            return customersService.proxyValidate($stateParams.token);
                        }
                        return null;
                    }
                }
            })
                .state('validateAccount', {
                templateUrl: "app/login/validate.tpl.html",
                url: "/validate_account/:token?send_to&cn&gi",
                controller: "LoginController",
                resolve: {
                    tokenAccess: function () { return null; },
                    tokenConfirm: function (customersService, $stateParams) {
                        if (angular.isDefined($stateParams.token) && $stateParams.token != '') {
                            return customersService.proxyValidate($stateParams.token);
                        }
                        return null;
                    }
                }
            })
                .state('accessAccount', {
                templateUrl: "app/login/access.tpl.html",
                url: "/due_negotiation/:token?send_to&cn&gi",
                controller: "LoginController",
                resolve: {
                    tokenConfirm: function () { return null; },
                    tokenAccess: function (customersService, $stateParams) {
                        if (angular.isDefined($stateParams.token) && $stateParams.token != '') {
                            return customersService.proxyAccessToken($stateParams.token);
                        }
                        return null;
                    }
                }
            });
        }
        function run() {
            var config = angular.module(config_1.NAME, [
                'ui.router',
            ]);
            config.run(function ($rootScope, $state, authService, notify) {
                $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                    if (angular.isDefined(error.status) && error.status == 404) {
                        $state.go('app.notFound');
                    }
                    console.log("error", error);
                });
                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
                    if ($rootScope.stateChangeBypass) {
                        $rootScope.stateChangeBypass = false;
                        return;
                    }
                    event.preventDefault();
                    if (!authService.isWhiteListStates(toState.name)) {
                        authService.isLoggedIn().then(function (response) {
                            $rootScope.stateChangeBypass = true;
                            if (response.states.filter(function (item) { return item == toState.name; }).length == 0) {
                                console.log('State to not authorized:', toState.name);
                                notify('Acceso no autorizado', 'danger');
                                $state.go('app.dashboard');
                            }
                            else {
                                $state.go(toState, toParams);
                            }
                        }, function (responseError) {
                            $rootScope.stateChangeBypass = true;
                        });
                    }
                    else {
                        $rootScope.stateChangeBypass = true;
                        $state.go(toState, toParams);
                    }
                });
                $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    $("input").blur();
                    if (angular.isDefined(window.ga) && angular.isDefined(toState.url)) {
                        window.ga('set', 'page', toState.url);
                        window.ga('send', 'pageview');
                    }
                });
            });
            config.config(ConfigRoutes);
            config.config(function ($ocLazyLoadProvider) {
                $ocLazyLoadProvider.config({
                    debug: false,
                    events: false
                });
            });
        }
        config_1.run = run;
    })(config = finadai.config || (finadai.config = {}));
})(finadai || (finadai = {}));
finadai.config.run();

var finadai;
(function (finadai) {
    var app;
    (function (app_1) {
        app_1.NAME = 'finadai.app';
        function AppController($scope, $rootScope, $document, appConfig, $state, $mdSidenav, $mdComponentRegistry, whoIAm, negotiationStatus) {
            $scope.pageTransitionOpts = appConfig.pageTransitionOpts;
            $rootScope.app = appConfig.app;
            $rootScope.negotiationStatus = negotiationStatus;
            $scope.color = appConfig.color;
            $rootScope.loggedUser = whoIAm;
            // Checks if the given state is the current state
            $scope.is = function (name) { return $state.is(name); };
            // Checks if the given state/child states are present
            $scope.includes = function (name) { return $state.includes(name); };
            // 
            $rootScope.$on("$stateChangeSuccess", function (event, currentRoute, previousRoute) {
                $document.duScrollTo(0, 0);
            });
            // for mdSideNav right
            $scope.toggleRight = buildToggler('right');
            $scope.isOpenRight = function () {
                if (!$mdComponentRegistry.get('right'))
                    return;
                return $mdSidenav('right').isOpen();
            };
            function buildToggler(navID) {
                return function () {
                    // Component lookup should always be available since we are not using `ng-if`
                    $mdSidenav(navID).toggle();
                };
            }
        }
        function appConfig() {
            var pageTransitionOpts = [
                {
                    name: 'Fade up',
                    "class": 'animate-fade-up'
                }, {
                    name: 'Scale up',
                    "class": 'ainmate-scale-up'
                }, {
                    name: 'Slide in from right',
                    "class": 'ainmate-slide-in-right'
                }, {
                    name: 'Flip Y',
                    "class": 'animate-flip-y'
                }
            ];
            var date = new Date();
            var year = date.getFullYear();
            var app = {
                brand: 'Quam',
                user: 'Jane',
                year: year,
                pageTransition: pageTransitionOpts[0],
                layoutBoxed: false,
                navCollapsed: false,
                navBehind: false,
                fixedHeader: true,
                sidebarWidth: 'middle',
                theme: 'light',
                colorOption: '21',
                link: 'http://www.quam.mx/',
                phone: '01 (800) 123 4567'
            };
            var color = {
                primary: 'rgba(33,150,243,.7)',
                success: 'rgba(102,187,106,.7)',
                info: 'rgba(0,188,212,.7)',
                infoAlt: 'rgba(126,87,194,.7)',
                warning: 'rgba(255,202,40,.7)',
                danger: 'rgba(233,75,59,.7)',
                gray: '#EF5350'
            };
            return {
                pageTransitionOpts: pageTransitionOpts,
                app: app,
                color: color
            };
        }
        function mdConfig($mdThemingProvider) {
            var cyanAlt = $mdThemingProvider.extendPalette('cyan', {
                'contrastLightColors': '500 600 700 800 900',
                // 'contrastStrongLightColors': '500 600 700 800 900'
            });
            var greenAlt = $mdThemingProvider.extendPalette('green', {
                'contrastLightColors': '400 500 600 700 800 900',
                // 'contrastStrongLightColors': '400 500 600 700 800 900'
            });
            $mdThemingProvider
                .definePalette('cyanAlt', cyanAlt)
                .definePalette('greenAlt', greenAlt);
            $mdThemingProvider.theme('default')
                .primaryPalette('blue', {
                'default': '500'
            })
                .accentPalette('greenAlt', {
                'default': '400'
            })
                .warnPalette('red', {
                'default': '400'
            })
                .backgroundPalette('grey');
        }
        function HeaderController($scope, authService, $state, customersService, $rootScope) {
            $scope.pendingNegotiations = [];
            $scope.logout = function () {
                authService.logout().then(function (response) { $state.go('login'); });
            };
            function updatePendingNegotiations() {
                if (authService.currentUser.privilege == 'customer') {
                    customersService.getPendingNegotiations().then(function (response) {
                        $scope.pendingNegotiations = response.data.data;
                    });
                }
            }
            // updatePendingNegotiations();
            $rootScope.$on('updatePendingNegotiations', updatePendingNegotiations);
        }
        function run() {
            var app = angular.module(app_1.NAME, [
                'ui.router',
                'ngAnimate',
                'ngAria',
                'ngMessages',
                'ngSanitize',
                // 3rd Party Modules
                'oc.lazyLoad',
                'ngMaterial',
                'md.data.table',
                'duScroll',
                'finadai.theme',
                'angularFileUpload',
                finadai.lang.NAME,
                finadai.config.NAME,
                finadai.app.dashboard.NAME,
                finadai.app.forgotPassword.NAME,
                finadai.app.changePassword.NAME,
                finadai.app.register.NAME,
                finadai.app.login.NAME,
                finadai.app.findYourCredit.NAME,
                finadai.app.payYourCredit.NAME,
                finadai.app.upload.NAME,
                finadai.filters.NAME,
                finadai.directives.NAME,
                finadai.services.NAME,
                finadai.app.search.NAME,
                finadai.app.negotiations.NAME,
                finadai.app.payments.NAME,
                finadai.app.activities.NAME,
                finadai.app.granters.NAME,
                finadai.app.agents.NAME,
                finadai.app.customers.NAME,
                finadai.app.customers.cancel_negotiation.NAME,
                finadai.app.admin.NAME,
                finadai.app.admin.create.NAME,
                finadai.app.admin.search.NAME,
                finadai.app.admin.find.NAME,
                finadai.app.admin.create_reference.NAME,
                finadai.app.admin.change_sic.NAME,
                finadai.app.admin.cancel_negotiation.NAME,
                finadai.app.admin.update.NAME
            ]);
            app.factory('appConfig', appConfig);
            app.config(mdConfig);
            app.controller('AppController', AppController);
            app.controller('HeaderController', HeaderController);
            app.constant('negotiationStatus', { new: 'Nueva', pending: 'Pendiente', complete: 'Completada', cancelled: 'Cancelada', paid: 'Pagada' });
        }
        app_1.run = run;
    })(app = finadai.app || (finadai.app = {}));
})(finadai || (finadai = {}));
finadai.app.run();
